/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  // isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  isTouch: ('ontouchstart' in window || (window.DocumentTouch && window.document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints) && window.innerWidth < 1024 ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

// if (console && console.log) {
//   console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
// }

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      let a = '';
      let b = '';
      let c = '';
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        if (['checkbox', 'radio'].includes(field.type) && field.hasAttribute('data-variant-input')) {
          if (!a) {
            a = field.value;
          } else if (!b) {
            b = field.value;
          } else if (!c) {
            c = field.value;
          }
        }
        // 加载theme.js后重新查找所选variant并重新赋值option和id
        if (field.name === 'id' && document.body.classList.contains('template-product') && !form.closest('#CartDrawer') && !form.closest('.coustomrem') && !form.closest('#special-offer-popup')) {
          const prefix = `${a ? ` ${a} /` : ''}${b ? c ? ` ${b} /` : ` ${b} ` : ''}${c ? ` ${c} ` : ''}`;
          const options = document.querySelector('[data-product-select]').querySelectorAll('option');
          let value = '';
          options.forEach(option => {
            if ((option.innerHTML.trim()).indexOf(prefix.trim()) === 0 && option.innerHTML.trim().split(prefix.trim())[1]?.[0] === ' ') {
              value = option.getAttribute('value');
            }
          })
          if (value) {
            options.forEach(option => {
              option.removeAttribute('selected');
              if ((option.innerHTML.trim()).indexOf(prefix.trim()) === 0) {
                option.setAttribute('selected', 'selected');
              }
            })
            arr.push(
              encodeURIComponent(field.name) + '=' + encodeURIComponent(value)
            );
            return;
          }
        }
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.add('lock-scroll');
      // iOS：仅 overflow:hidden 挡不住背景滚动，需 fixed 锁住 body
      if (!document.body.classList.contains('is-drawer-scroll-locked')) {
        var y = window.scrollY || window.pageYOffset || 0;
        document.documentElement.setAttribute('data-scroll-lock-y', String(y));
        document.body.classList.add('is-drawer-scroll-locked');
        document.body.style.top = '-' + y + 'px';
      }
      var el = element ? element : document.documentElement;
      if (el && typeof el.on === 'function') {
        el.on('touchmove' + namespace, function(evt) {
          if (evt.target && evt.target.closest && evt.target.closest('.drawer, .modal, .cart-drawer__scroll-stack, .drawer__scrollable, .cart-drawer__aside-scroll')) {
            return true;
          }
          if (evt.cancelable) evt.preventDefault();
          return false;
        });
      }
    },

    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      if (document.body.classList.contains('is-drawer-scroll-locked')) {
        var y = parseInt(document.documentElement.getAttribute('data-scroll-lock-y') || '0', 10) || 0;
        document.body.classList.remove('is-drawer-scroll-locked');
        document.body.style.top = '';
        document.documentElement.removeAttribute('data-scroll-lock-y');
        window.scrollTo(0, y);
      }
      var el = element ? element : document.documentElement;
      if (el && typeof el.off === 'function') {
        el.off('touchmove' + namespace);
      }
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  const trapFocusHandlers = {};
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function buildImagePath(string, widths) {
  
      if (string == null) return [];
  
      if (widths) {
        const imageUrls = [];
  
        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
    document.querySelectorAll('table.contained').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
      setTimeout(() => {
        this._variantImageInit();
        this.sizeVariantReset();
        window.addEventListener('resize', () => {
          this._variantImageInit();
          this.sizeVariantReset();
        });
      }, 0);
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      // size尺码变体、add to cart按钮位置重置
      sizeVariantReset: function() {
        if (this.container.getAttribute('data-section-type') == 'product') {
          const productBlockVariantPicker = this.container.querySelector('.product-block-variant-picker'); // 产品块变体
          const productBlockBuyButtons = this.container.querySelector('.product-block-buy-buttons'); // 产品块购买按钮
          const fixedSizeVariantWrapper = this.container.querySelector('.m-fixed-variant-wrapper'); // 底部固定尺码变体容器
          const sizeVariant = productBlockVariantPicker.querySelector('.variant-input-wrap[name="Size"]'); // 尺码变体
          const addToCartButton = productBlockBuyButtons.querySelector('form'); // add to cart按钮
          if (!fixedSizeVariantWrapper) {
            return;
          }
          const fixedBtnWrapper = fixedSizeVariantWrapper.querySelector('.tab-btn'); // 底部固定按钮容器
          if (window.innerWidth < 768 && !fixedSizeVariantWrapper.querySelector('.variant-input-wrap[name="Size"]') && sizeVariant) {
            fixedSizeVariantWrapper.insertBefore(sizeVariant.parentElement, fixedBtnWrapper);
            fixedBtnWrapper.insertBefore(addToCartButton, null); // 将add to cart按钮移动到底部固定按钮容器中
          } else if (window.innerWidth >= 768 && fixedSizeVariantWrapper.querySelector('.variant-input-wrap[name="Size"]') && !sizeVariant) {
            const variantLastDom = productBlockVariantPicker.lastElementChild; // 产品块变体最后一个元素
            productBlockVariantPicker.insertBefore(fixedSizeVariantWrapper.querySelector('.variant-wrapper'), variantLastDom); // 将产品块变体移动到底部固定尺码变体容器中
            productBlockBuyButtons.insertBefore(fixedSizeVariantWrapper.querySelector('form'), productBlockBuyButtons.querySelector('div')); // 将产品块购买按钮移动到底部固定尺码变体容器中
          }
        }
      },
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
  
        return result;
      },
  
      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function(key) {
        return parseInt(key.substr(-1));
      },
  
      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function(variant) {
        return this._getCurrentOptions().reduce((count, {value, index}) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        },0)
      },
  
      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({value, index}) => {
            return variant[index] === value;
          });
  
          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },
  
      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function(lastSelectedOption) {
        if (!lastSelectedOption) return null;
  
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({value, index}) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({value, index}) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });
        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;
  
          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);
  
          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },
  
      _getVariantFromOptions: function(lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);
  
        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }
  
      },

      _getNextVariantFromOptions: function(nextVariantSelectedOption) {
        if (!nextVariantSelectedOption) return null;
  
        var result = [];
        const optionSelectElements = Array.from(this.container.querySelectorAll(this.singleOptionSelector)).reverse();
        const variantWrappers = this.container.querySelectorAll('.variant-wrapper');
        let upVis = 0;
        optionSelectElements.forEach((el, idx) => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              if (el.closest('.variant-wrapper') != variantWrappers[variantWrappers.length - 1]) {
                if (upVis === 0) {
                  if (el.closest('.variant-input').nextElementSibling) {
                    upVis+=1;
                    result.push({
                      value: optionSelectElements[idx - 1].value,
                      index: optionSelectElements[idx - 1].dataset.index
                    });
                  } else {
                    upVis+=2;
                    result.push({
                      value: el.closest('.variant-wrapper').querySelectorAll('input')[0].value,
                      index: el.closest('.variant-wrapper').querySelectorAll('input')[0].dataset.index
                    });
                  }
                } else if (upVis === 1) {
                  result.push({
                    value: el.value,
                    index: el.dataset.index
                  });
                } else {
                  result.push({
                    value: optionSelectElements[idx - 1].value,
                    index: optionSelectElements[idx - 1].dataset.index
                  });
                }
              } else {
                result.push({
                  value: el.value,
                  index: el.dataset.index
                });
              }
            }
          }
        });
        if (!result.length) {
          return null;
        }
        const currentlySelectedOptions = theme.utils.compact(result);
        const variants = this.variants;
  
        return nextVariantSelectedOption ? variants.find(variant => {
          return currentlySelectedOptions
            .every(({value, index}) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            })
        }) : null;
      },
  
      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;
  
          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');
          const isBundle = input.dataset.bundle; // 是否捆绑产品
  
          if (type === 'radio' || type === 'checkbox') {
            if (isBundle) {
              return;
            }
            input.checked = variant[index] === value
            if (input.checked) {
              input.dispatchEvent(new Event('updateSwatch'));
            }
          } else {
            input.value = variant[index];
          }
        }
      },
  
      _variantImageInit: function() {
        let variant = null;
        let nextVariant = null;
        let optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
        optionSelectElements.forEach((el, idx) => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked && !el.closest('.variant-wrapper').previousElementSibling) {
              variant = this._getVariantFromOptions({
                index: el.dataset.index,
                value: el.value
              });
              if (optionSelectElements[idx + 1] && !optionSelectElements[idx + 1].closest('.variant-wrapper').previousElementSibling) {
                nextVariant = this._getNextVariantFromOptions({
                  index: optionSelectElements[idx + 1].dataset.index,
                  value: optionSelectElements[idx + 1].value
                });
              }
            }
          }
        });
        if (variant){
          this.container.dispatchEvent(new CustomEvent('variantImageInit', {
            detail: {
              variant: variant,
              nextVariant: nextVariant
            }
          }));
        }
      },

      _onSelectChange: function({srcElement}) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });
        let nextVariant = null;
        let handleLastVariant = false;
        const variantWrappers = srcElement.closest('.product-block').querySelectorAll('.variant-wrapper'); // 获取当前产品块的所有变体
        const lastVariantWrapper = variantWrappers[variantWrappers.length - 1]; // 获取当前产品块的最后一个变体
        const lastVariant = lastVariantWrapper.querySelectorAll('.variant-input')[lastVariantWrapper.querySelectorAll('.variant-input').length - 1]; // 获取当前产品块的最后一个变体的最后一个选项
        // let lastReturnVariant = null;
        // variantWrappers[variantWrappers.length - 2].querySelectorAll('input').forEach((item, index) => {
        //   if (item.checked && item.parentElement.nextElementSibling) {
        //     lastReturnVariant = item.parentElement.nextElementSibling.children[0];
        //   }
        // });
        if (srcElement.closest('.variant-wrapper') == lastVariantWrapper && srcElement.closest('.variant-input') == lastVariant) { // 如果当前选项是当前产品块的最后一个变体的最后一个选项
          handleLastVariant = true;
        } else if (srcElement.parentElement.nextElementSibling) { // 如果当前选项有下一个选项
          const nextSrcElement = srcElement.parentElement.nextElementSibling.children[0];
          nextVariant = this._getNextVariantFromOptions({
            index: nextSrcElement.dataset.index,
            value: nextSrcElement.value
          });
        } else {
          nextVariant = this._getNextVariantFromOptions({
            index: srcElement.dataset.index,
            value: srcElement.value
          });
        }
        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))
  
        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();
  
        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
        document.dispatchEvent(new CustomEvent('variant:change', {detail}));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant, nextVariant, handleLastVariant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant, nextVariant, handleLastVariant) {
        if (!variant.featured_image) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant,
            nextVariant: nextVariant,
            handleLastVariant,
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }
        const stockoutEles = this.container.querySelectorAll('.stockout-sku-container-gzg');
        // 判断显示缺货sku
        if(stockoutEles){
          stockoutEles.forEach(ele => {
            const stockSku = ele.dataset.stockoutsku;
            if(stockSku.indexOf(variant.sku) !== -1){
              ele.style.display = 'block';
            }else{
              ele.style.display = 'none';
            }
          })
        }
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;
  
        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true
        theme.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }
  
  function checkIfVimeoIsReady () {
    let wait
    let timeout
  
    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return
        }
  
        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)
  
      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }
  
  theme.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }
  
    function VimeoPlayer (divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }
  
      this.setAsLoading()
  
      if (theme.config.vimeoReady) {
        this.init()
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId
  
        this.videoPlayer = new Vimeo.Player(this.el, args)
  
        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },
  
      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')
  
        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }
  
        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }
  
        this.setAsLoaded()
  
        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })
  
        observer.observe(this.iframe)
      },
  
      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },
  
      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },
  
      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },
  
      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },
  
      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })
  
    return VimeoPlayer
  })()
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  // Prevent vertical scroll while using flickity sliders
  (function() {
    var e = !1;
    var t;
  
    document.body.addEventListener('touchstart', function(i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })
  
    document.body.addEventListener('touchmove', function(i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();
  

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }
  
    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)
  
        const sectionRenders = this.sections.map(section => {
  
          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;
  
          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });
  
        if (updateURLHash) this.updateURLHash(updatedParams);
  
        return Promise.all(sectionRenders);
      },
  
      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);
  
        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },
  
      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
  
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },
  
      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );
  
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }
  
            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }
  
        return section;
      },
  
      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
  
        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }
  
        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }
  
        return clone;
      },
  
      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
      },
  
      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });
  
    return AjaxRenderer;
  })();
  
  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(response => response.text())
      .catch(e => console.error(e));
    },
  
    changeItem: function(key, qty) {
  
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => { return response.text() })
      .then(cart => { return cart; });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    },

    _autoGiftBagPriceInFlight: false,
    _autoGiftBagPriceFailedVariantIds: {},
    _autoGiftBagPriceAddTimer: null,
    _autoGiftBagPriceScheduledVariantId: null,
    _autoGiftAddQueueKey: null,
    _autoGiftPendingUpdates: null,
    _autoGiftPendingAdds: null,
    // 满额手动赠领取锁：防止藏卡前连点/换尺码叠件
    _priceGiftClaimLock: false,

    cancelScheduledAutoGiftBagPriceAdd: function() {
      if (theme.cart._autoGiftBagPriceAddTimer) {
        clearTimeout(theme.cart._autoGiftBagPriceAddTimer);
        theme.cart._autoGiftBagPriceAddTimer = null;
      }
      theme.cart._autoGiftBagPriceScheduledVariantId = null;
      theme.cart._autoGiftAddQueueKey = null;
    },

    _postCartJsonXHR: function(url, payloadObj) {
      return new Promise(function(resolve, reject) {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open('POST', url, true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.onload = function() {
            var body = xhr.responseText;
            var data = null;
            if (body) {
              try {
                data = JSON.parse(body);
              } catch (e) {
                data = null;
              }
            }
            resolve({
              ok: xhr.status >= 200 && xhr.status < 300,
              status: xhr.status,
              data: data
            });
          };
          xhr.onerror = function() {
            reject(new Error('xhr'));
          };
          xhr.send(JSON.stringify(payloadObj));
        } catch (e) {
          reject(e);
        }
      });
    },

    _giftBagPriceRequestWith429Retry: function(requestFn, maxAttempts) {
      maxAttempts = maxAttempts || 4;
      var attempt = function(n) {
        return requestFn().then(function(result) {
          if (result.status === 429 && n < maxAttempts) {
            return new Promise(function(resolve) {
              setTimeout(function() {
                resolve(attempt(n + 1));
              }, 1800 * n);
            });
          }
          return result;
        });
      };
      return attempt(1);
    },

    /**
     * Shared auto-gift sync for price_auto + slot2/3 BXGY.
     * Prefer cart/update (variant id → qty) before debounced adds.
     * Price threshold semantics unchanged: Liquid still decides price remove vs add.
     */
    processAutoGiftTriggers: function(opts) {
      opts = opts || {};
      var updates = {};
      var hasUpdate = false;
      var addJobs = [];
      var seenVariant = {};

      var collectRemoveKeys = function(el) {
        if (!el) return;
        var variantId = el.getAttribute('data-variant-id');
        if (variantId) {
          updates[String(variantId)] = 0;
          hasUpdate = true;
          return;
        }
        var keysStr = el.getAttribute('data-line-keys');
        if (!keysStr) return;
        keysStr.split('|').filter(Boolean).forEach(function(k) {
          updates[k] = 0;
          hasUpdate = true;
        });
      };

      var collectAdd = function(el, failPrefix, quantity) {
        if (!el) return;
        var variantId = el.getAttribute('data-variant-id');
        if (!variantId || seenVariant[variantId]) return;
        var qty = quantity != null ? Number(quantity) : 1;
        if (!qty || qty < 1) return;
        seenVariant[variantId] = true;
        var slot = el.getAttribute('data-slot') || '';
        var failKey = failPrefix + (slot ? slot + ':' : '') + variantId + ':q' + qty;
        addJobs.push({
          variantId: String(variantId),
          quantity: qty,
          failKey: failKey
        });
      };

      var collectSlotSync = function(el) {
        if (!el) return;
        var targetQty = parseInt(el.getAttribute('data-target-qty'), 10);
        if (isNaN(targetQty) || targetQty < 0) return;
        var keys = (el.getAttribute('data-line-keys') || '').split('|').filter(Boolean);
        var variantId = el.getAttribute('data-variant-id');
        if (!variantId) return;

        // /cart/update.js expects variant_id (or line key); variant_id is reliable for set/clear.
        if (targetQty === 0) {
          updates[String(variantId)] = 0;
          hasUpdate = true;
          return;
        }

        if (keys.length) {
          updates[String(variantId)] = targetQty;
          hasUpdate = true;
          return;
        }

        collectAdd(el, 'slot-sync:', targetQty);
      };

      collectRemoveKeys(opts.priceGiftRemoveEl);
      if (opts.slotGiftRemoveEls && opts.slotGiftRemoveEls.length) {
        Array.prototype.forEach.call(opts.slotGiftRemoveEls, collectRemoveKeys);
      }
      if (opts.slotGiftSyncEls && opts.slotGiftSyncEls.length) {
        Array.prototype.forEach.call(opts.slotGiftSyncEls, collectSlotSync);
      }

      if (hasUpdate) {
        theme.cart.cancelScheduledAutoGiftBagPriceAdd();
        theme.cart.runAutoGiftRemoves(updates);
        return;
      }

      if (opts.priceGiftAutoEl) {
        collectAdd(opts.priceGiftAutoEl, 'price:', 1);
      }
      if (opts.slotGiftAddEls && opts.slotGiftAddEls.length) {
        Array.prototype.forEach.call(opts.slotGiftAddEls, function(el) {
          collectAdd(el, 'slot:', 1);
        });
      }

      if (!addJobs.length) {
        theme.cart.cancelScheduledAutoGiftBagPriceAdd();
        return;
      }

      var delayMs = 50;
      var i;
      for (i = 0; i < addJobs.length; i++) {
        if (addJobs[i].failKey && addJobs[i].failKey.indexOf('price:') === 0) {
          delayMs = 900;
          break;
        }
      }
      theme.cart.scheduleAutoGiftAdds(addJobs, delayMs);
    },

    runAutoGiftRemoves: function(updates) {
      if (!updates || !Object.keys(updates).length) {
        return;
      }
      if (theme.cart._autoGiftBagPriceInFlight) {
        theme.cart._autoGiftPendingUpdates = Object.assign(
          {},
          theme.cart._autoGiftPendingUpdates || {},
          updates
        );
        return;
      }
      theme.cart._autoGiftBagPriceInFlight = true;
      theme.cart._autoGiftPendingUpdates = null;
      theme.cart
        ._giftBagPriceRequestWith429Retry(function() {
          return theme.cart._postCartJsonXHR('/cart/update.js', { updates: updates });
        })
        .then(function(result) {
          theme.cart._autoGiftBagPriceInFlight = false;
          if (result.ok && result.data != null) {
            theme.cart._autoGiftBagPriceFailedVariantIds = {};
            theme.cart._autoGiftPendingAdds = null;
            document.dispatchEvent(new CustomEvent('cart:build'));
            return;
          }
          theme.cart._drainPendingAutoGifts(false);
        })
        .catch(function() {
          theme.cart._autoGiftBagPriceInFlight = false;
          theme.cart._drainPendingAutoGifts(false);
        });
    },

    _drainPendingAutoGifts: function(anySuccess, skipVariantIds) {
      skipVariantIds = skipVariantIds || {};
      if (theme.cart._autoGiftPendingUpdates) {
        var pendingUpdates = theme.cart._autoGiftPendingUpdates;
        theme.cart._autoGiftPendingUpdates = null;
        theme.cart.runAutoGiftRemoves(pendingUpdates);
        return;
      }
      if (theme.cart._autoGiftPendingAdds && theme.cart._autoGiftPendingAdds.length) {
        var pendingAdds = theme.cart._autoGiftPendingAdds.filter(function(job) {
          return job && job.variantId && !skipVariantIds[String(job.variantId)];
        });
        theme.cart._autoGiftPendingAdds = null;
        if (pendingAdds.length) {
          theme.cart.runAutoGiftAddsSerial(pendingAdds);
          return;
        }
      }
      if (anySuccess) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    },

    scheduleAutoGiftAdds: function(addJobs, delayMs) {
      if (!addJobs || !addJobs.length) {
        theme.cart.cancelScheduledAutoGiftBagPriceAdd();
        return;
      }
      delayMs = delayMs == null ? 50 : delayMs;
      var queueKey = addJobs
        .map(function(j) {
          return j.failKey;
        })
        .sort()
        .join('|');
      if (
        theme.cart._autoGiftBagPriceAddTimer &&
        theme.cart._autoGiftAddQueueKey === queueKey
      ) {
        return;
      }
      theme.cart.cancelScheduledAutoGiftBagPriceAdd();
      theme.cart._autoGiftAddQueueKey = queueKey;
      theme.cart._autoGiftBagPriceScheduledVariantId =
        addJobs.length === 1 ? addJobs[0].variantId : queueKey;
      theme.cart._autoGiftBagPriceAddTimer = setTimeout(function() {
        theme.cart._autoGiftBagPriceAddTimer = null;
        theme.cart._autoGiftBagPriceScheduledVariantId = null;
        theme.cart._autoGiftAddQueueKey = null;
        theme.cart.runAutoGiftAddsSerial(addJobs);
      }, delayMs);
    },

    runAutoGiftAddsSerial: function(addJobs) {
      if (!addJobs || !addJobs.length) {
        return;
      }
      if (theme.cart._autoGiftBagPriceInFlight) {
        theme.cart._autoGiftPendingAdds = addJobs;
        return;
      }

      var remaining = addJobs.filter(function(job) {
        return (
          job &&
          job.variantId &&
          !theme.cart._autoGiftBagPriceFailedVariantIds[job.failKey] &&
          !theme.cart._autoGiftBagPriceFailedVariantIds[job.variantId]
        );
      });
      if (!remaining.length) {
        theme.cart._drainPendingAutoGifts(false);
        return;
      }

      theme.cart._autoGiftBagPriceInFlight = true;
      var attemptedIds = {};
      remaining.forEach(function(job) {
        attemptedIds[String(job.variantId)] = true;
      });

      var finishAdds = function(anySuccess) {
        theme.cart._autoGiftBagPriceInFlight = false;
        theme.cart._drainPendingAutoGifts(anySuccess, attemptedIds);
      };

      var runNext = function(index, anySuccess) {
        if (index >= remaining.length) {
          finishAdds(anySuccess);
          return;
        }
        var job = remaining[index];
        var qty = Number(job.quantity) || 1;
        theme.cart
          ._giftBagPriceRequestWith429Retry(function() {
            return theme.cart._postCartJsonXHR(theme.routes.cartAdd, {
              items: [{ id: Number(job.variantId), quantity: qty }]
            });
          })
          .then(function(result) {
            var data = result.data;
            if (data && data.status === 422) {
              theme.cart._autoGiftBagPriceFailedVariantIds[job.failKey] = true;
              theme.cart._autoGiftBagPriceFailedVariantIds[job.variantId] = true;
              runNext(index + 1, anySuccess);
              return;
            }
            if (!result.ok || data == null) {
              finishAdds(anySuccess);
              return;
            }
            runNext(index + 1, true);
          })
          .catch(function() {
            finishAdds(anySuccess);
          });
      };

      runNext(0, false);
    },

    maybeRemoveAutoGiftBagPrice: function(triggerEl) {
      theme.cart.processAutoGiftTriggers({
        priceGiftRemoveEl: triggerEl || document.querySelector('.js-auto-gift-bag-price-remove')
      });
    },

    scheduleAutoGiftBagPriceAdd: function(triggerEl) {
      if (!triggerEl) {
        theme.cart.cancelScheduledAutoGiftBagPriceAdd();
        return;
      }
      theme.cart.processAutoGiftTriggers({
        priceGiftAutoEl: triggerEl
      });
    },

    runAutoGiftBagPriceAddVariant: function(variantId) {
      if (!variantId) {
        return;
      }
      theme.cart.runAutoGiftAddsSerial([
        { variantId: String(variantId), quantity: 1, failKey: 'price:' + variantId + ':q1' }
      ]);
    },

    maybeAutoAddGiftBagPrice: function(triggerEl) {
      theme.cart.scheduleAutoGiftBagPriceAdd(triggerEl);
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
  
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);
  
      this.cartItemsUpdated = false;
      // 添加触发状态标记：初始未触发
      this.hasTriggered200 = false;
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();

    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
  
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
  
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);
  
        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.
  
          Error is handled in the quantityChanged method
  
          For Expanse/Fetch/Gem quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.
  
          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch/Gem when using quick add
        */
  
        if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
          document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(text) {
        const html = document.createElement('div');
        html.innerHTML = text;
        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts'),
          maxOut: html.querySelector('.maxOut'),
          cartRecommended: html.querySelector('.cart-recommended'),
          cartGiftBaged: html.querySelector('.product-gif-cart-bag-cart'),
          priceGiftRemoveEl: html.querySelector('.js-auto-gift-bag-price-remove'),
          priceGiftAutoEl: html.querySelector('.js-auto-gift-bag-price'),
          slotGiftRemoveEls: html.querySelectorAll('.js-auto-giftbag-slot-remove'),
          slotGiftAddEls: html.querySelectorAll('.js-auto-giftbag-slot'),
          slotGiftSyncEls: html.querySelectorAll('.js-auto-giftbag-slot-sync')
        }
      },
  
      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },
  
      cartMarkup: function(text) {
        var markup = this._parseProductHTML(text || '');
        var priceGiftRemoveEl = markup.priceGiftRemoveEl;
        var priceGiftAutoEl = markup.priceGiftAutoEl;
        var slotGiftRemoveEls = markup.slotGiftRemoveEls;
        var slotGiftAddEls = markup.slotGiftAddEls;
        var slotGiftSyncEls = markup.slotGiftSyncEls;
        var syncAutoGifts = function() {
          theme.cart.processAutoGiftTriggers({
            priceGiftRemoveEl: priceGiftRemoveEl,
            priceGiftAutoEl: priceGiftAutoEl,
            slotGiftRemoveEls: slotGiftRemoveEls,
            slotGiftAddEls: slotGiftAddEls,
            slotGiftSyncEls: slotGiftSyncEls
          });
        };
        if (!markup.items) {
          syncAutoGifts();
          theme.cart._priceGiftClaimLock = false;
          return;
        }
        var items = markup.items;
        var count = parseInt(items.dataset.count, 10);
        var subtotal = items.dataset.cartSubtotal;
        // 优惠前的总价
        var cartTotal = items.dataset.cartTotal;
        var savings = items.dataset.cartSavings;
  
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
  
        this.updateCount(count);
  
        // Append item markup
        this.products.innerHTML = '';

        this.products.append(items);
        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        const originalSubtotalEl = this.form.querySelector('[data-subtotal-original]');
        const cartDiscount = Number(items.dataset.cartDiscount) || 0;
        const hasDiscount = cartDiscount > 0 || (Number(cartTotal) || 0) > (Number(subtotal) || 0);
        if (originalSubtotalEl) {
          originalSubtotalEl.innerHTML = theme.Currency.formatMoney(cartTotal, theme.settings.moneyFormat);
          originalSubtotalEl.classList.toggle('hide', !hasDiscount);
        }
        const bestOfferEl = this.form.querySelector('[data-best-offer]');
        if (bestOfferEl) {
          bestOfferEl.classList.toggle('hide', !hasDiscount);
        }
        const maxOutReset = document.querySelector('.maxOut');
        if (maxOutReset) maxOutReset.innerHTML = '';
        if(document.querySelector('#giftBag')) {
          const giftBags = document.querySelectorAll('#giftBag');

          var dataEventBag = 0;
          giftBags.forEach(bag => {
              const qtyInput = bag.querySelector('.js-qty__num');
              const qty = qtyInput.getAttribute('value');
              const bagPriceValue = bag.getAttribute('data-item-bagPrice');
              const bagPriceTotal = Number(qty) * Number(bagPriceValue);
              dataEventBag += bagPriceTotal * window.Shopify.currency.rate;
          });
        } else {
          var dataEventBag = 0;
        }
        if(document.querySelector('.drawer__scrollable .manHeCount')) {
          const manHeCount = document.querySelectorAll('.drawer__scrollable .manHeCount');

          var hxCount = 0;
          manHeCount.forEach(item => {
              const qtyInput = item.querySelector('.js-qty__num');
              const qty = qtyInput.getAttribute('value');
              const hxCountTotal = Number(qty) 
              hxCount += hxCountTotal
          });
        } else {
          var hxCount = 0;
        }
        const currencyRate = window.Shopify.currency && window.Shopify.currency.rate ? window.Shopify.currency.rate : 1;
        const cartFinalTotal = (Number(items.dataset.cartSubtotal) || 0) * currencyRate;
        const discountItemCount = parseInt(items.dataset.discountItemCount, 10) || 0;
        const shippingBar = document.querySelector('free-shipping-bar');
        const maxoutEle = document.querySelector('.maxOut');
        const moneyFmt = theme.settings.currency_code_enable ? theme.moneyWithCurrencyFormat : theme.moneyFormat;
        const formatMoney = (amt) => theme.Currency.formatMoney(amt, moneyFmt);

        /* ========== [旧逻辑] 金额阶梯进度条 + take_part_in_discount 切换件数模式（已停用，勿删便于回滚）
        const rewardCollectionOriginalTotal = (Number(items.dataset.rewardCollectionOriginalTotal) || 0) * currencyRate;
        const amountSteps = [
          { threshold: 100 * 100 * currencyRate, title: '$100', subtitle: 'Free Shipping' },
          { threshold: 150 * 100 * currencyRate, title: '$150', subtitle: '$20 Off' },
          { threshold: 180 * 100 * currencyRate, title: '$180', subtitle: '$30 Off' },
          { threshold: 250 * 100 * currencyRate, title: '$250', subtitle: '$50 Off' }
        ];
        const quantityStepsOld = [
          { threshold: 2, title: '2 Items', subtitle: '20% Off' },
          { threshold: 3, title: '3 Items', subtitle: '40% Off' },
          { threshold: 4, title: '4 Items', subtitle: '80% Off' }
        ];
        const amountAnchors = [14, 42, 71, 100];
        const quantityAnchorsOld = [14, 57, 100];
        const getQuantityProgressOld = (itemCount) => {
          if (itemCount <= 0) return 0;
          if (itemCount < 2) return (itemCount / 2) * quantityAnchorsOld[0];
          if (itemCount < 3) return quantityAnchorsOld[0] + ((itemCount - 2) / 1) * (quantityAnchorsOld[1] - quantityAnchorsOld[0]);
          if (itemCount < 4) return quantityAnchorsOld[1] + ((itemCount - 3) / 1) * (quantityAnchorsOld[2] - quantityAnchorsOld[1]);
          return 100;
        };
        const getAmountProgress = (finalTotal, originalTotal) => {
          if (finalTotal <= 0 && originalTotal <= 0) return 0;
          if (finalTotal < amountSteps[0].threshold) {
            return clamp((finalTotal / amountSteps[0].threshold) * amountAnchors[0], 0, amountAnchors[0]);
          }
          if (originalTotal < amountSteps[1].threshold) {
            return amountAnchors[0] + clamp(((originalTotal - amountSteps[0].threshold) / (amountSteps[1].threshold - amountSteps[0].threshold)) * (amountAnchors[1] - amountAnchors[0]), 0, amountAnchors[1] - amountAnchors[0]);
          }
          if (originalTotal < amountSteps[2].threshold) {
            return amountAnchors[1] + clamp(((originalTotal - amountSteps[1].threshold) / (amountSteps[2].threshold - amountSteps[1].threshold)) * (amountAnchors[2] - amountAnchors[1]), 0, amountAnchors[2] - amountAnchors[1]);
          }
          if (originalTotal < amountSteps[3].threshold) {
            return amountAnchors[2] + clamp(((originalTotal - amountSteps[2].threshold) / (amountSteps[3].threshold - amountSteps[2].threshold)) * (amountAnchors[3] - amountAnchors[2]), 0, amountAnchors[3] - amountAnchors[2]);
          }
          return 100;
        };
        const isQuantityDiscountMode = shippingBar && shippingBar.dataset.takePartInDiscount === 'true' && count > 0;
        if (shippingBar) {
          const stepsContainer = shippingBar.querySelector('[data-shipping-bar-steps]');
          if (count === 0 || !isQuantityDiscountMode) {
            const progress = count === 0 ? 0 : getAmountProgress(cartFinalTotal, rewardCollectionOriginalTotal);
            shippingBar.style.setProperty('--progress', `${progress}%`);
            shippingBar.style.setProperty('--steps-count', amountSteps.length);
            shippingBar.setAttribute('data-steps-count', amountSteps.length);
            if (stepsContainer) {
              stepsContainer.innerHTML = amountSteps.map((step, index) => {
                if (count === 0) return buildProgressMarkup(step, false);
                const isActive = index === 0 ? cartFinalTotal >= step.threshold : rewardCollectionOriginalTotal >= step.threshold;
                return buildProgressMarkup(step, isActive);
              }).join('');
            }
          } else {
            const progress = getQuantityProgressOld(discountItemCount);
            shippingBar.style.setProperty('--progress', `${progress}%`);
            shippingBar.style.setProperty('--steps-count', quantityStepsOld.length);
            shippingBar.setAttribute('data-steps-count', quantityStepsOld.length);
            if (stepsContainer) {
              stepsContainer.innerHTML = quantityStepsOld.map((step) => buildProgressMarkup(step, discountItemCount >= step.threshold)).join('');
            }
          }
        }
        ========== */

        // [新逻辑] 免邮：全车 subtotal ≥ $100；多件多折：仅集合 304091889840 件数
        // 进度条固定 4 节点：2→20% / 3→50% / 4→80% / 5→FREE
        const freeShippingThreshold = 100 * 100 * currencyRate;
        // 节点上方用序数：到达集合内第 N 件时解锁下方奖励（无 1st，因第 2 件才开始打折）
        const quantitySteps = [
          { threshold: 2, title: '2nd', subtitle: '20% OFF' },
          { threshold: 3, title: '3rd', subtitle: '50% OFF' },
          { threshold: 4, title: '4th', subtitle: '80% OFF' },
          { threshold: 5, title: '5th', subtitle: 'FREE' }
        ];
        const quantityAnchors = [14, 42, 71, 100];
        const buildProgressMarkup = (step, active) => `
          <div class="shipping-bar__step${active ? ' is-active' : ''}">
            <div class="shipping-bar__step-node">${step.title}</div>
            <div class="shipping-bar__step-label">${step.subtitle}</div>
          </div>
        `;
        const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
        const getQuantityProgress = (itemCount) => {
          if (itemCount <= 0) return 0;
          if (itemCount < 2) return clamp((itemCount / 2) * quantityAnchors[0], 0, quantityAnchors[0]);
          if (itemCount < 3) return quantityAnchors[0] + ((itemCount - 2) / 1) * (quantityAnchors[1] - quantityAnchors[0]);
          if (itemCount < 4) return quantityAnchors[1] + ((itemCount - 3) / 1) * (quantityAnchors[2] - quantityAnchors[1]);
          if (itemCount < 5) return quantityAnchors[2] + ((itemCount - 4) / 1) * (quantityAnchors[3] - quantityAnchors[2]);
          return 100;
        };
        const getQuantityCopy = (qty) => {
          if (qty <= 0) return 'Add 2 more items for 20% off.';
          if (qty === 1) return 'Add 1 more item for 20% off.';
          if (qty === 2) return '20% off unlocked. Add 1 more item for 50% off.';
          if (qty === 3) return '50% off unlocked. Add 1 more item for 80% off.';
          if (qty === 4) return '80% off unlocked. Add 1 more item to unlock a FREE item.';
          return 'FREE item unlocked! Checkout Now!';
        };

        if (shippingBar) {
          shippingBar.style.display = 'block';
          const stepsContainer = shippingBar.querySelector('[data-shipping-bar-steps]');
          const progress = count === 0 ? 0 : getQuantityProgress(discountItemCount);
          shippingBar.style.setProperty('--progress', `${progress}%`);
          shippingBar.style.setProperty('--steps-count', quantitySteps.length);
          shippingBar.setAttribute('data-steps-count', quantitySteps.length);
          if (stepsContainer) {
            stepsContainer.innerHTML = quantitySteps.map((step) =>
              buildProgressMarkup(step, count > 0 && discountItemCount >= step.threshold)
            ).join('');
          }
        }

        /* ========== [旧逻辑] 动态文案（金额满减 / 旧件数 20-40-80）（已停用，勿删便于回滚）
        let rewardTextOld = '';
        if (count === 0) {
          rewardTextOld = 'Free shipping on orders over $100';
        } else if (isQuantityDiscountMode) {
          if (discountItemCount < 2) {
            const qtyNeeded = 2 - discountItemCount;
            rewardTextOld = `Add ${qtyNeeded} more item${qtyNeeded > 1 ? 's' : ''} to unlock 20% off.`;
          } else if (discountItemCount < 3) {
            rewardTextOld = '20% off unlocked. Add 1 more item to unlock 40% off.';
          } else if (discountItemCount < 4) {
            rewardTextOld = '40% off unlocked. Add 1 more item to unlock 80% off.';
          } else {
            rewardTextOld = '80% off unlocked. Shop now!';
          }
        } else if (cartFinalTotal < amountSteps[0].threshold) {
          rewardTextOld = `Spend ${formatMoney(Math.max(0, amountSteps[0].threshold - cartFinalTotal))} to unlock free shipping.`;
        } else if (rewardCollectionOriginalTotal < amountSteps[1].threshold) {
          rewardTextOld = `Free shipping unlocked! Spend ${formatMoney(Math.max(0, amountSteps[1].threshold - rewardCollectionOriginalTotal))} more to get $20 off.`;
        } else if (rewardCollectionOriginalTotal < amountSteps[2].threshold) {
          rewardTextOld = `Free shipping unlocked! Spend ${formatMoney(Math.max(0, amountSteps[2].threshold - rewardCollectionOriginalTotal))} more to get $30 off.`;
        } else if (rewardCollectionOriginalTotal < amountSteps[3].threshold) {
          rewardTextOld = `Free shipping unlocked! Spend ${formatMoney(Math.max(0, amountSteps[3].threshold - rewardCollectionOriginalTotal))} more to get $50 off.`;
        } else {
          rewardTextOld = "You're eligible for all rewards! Shop now!";
        }
        ========== */

        // [新逻辑] 文案 = 免邮状态（全车金额）+ 多件多折状态（指定集合件数）
        let rewardText = '';
        if (count === 0) {
          rewardText = 'Spend $100 for free shipping.';
        } else {
          const underFreeShipping = cartFinalTotal < freeShippingThreshold;
          const shippingPrefix = underFreeShipping
            ? `Spend ${formatMoney(Math.max(0, freeShippingThreshold - cartFinalTotal))} more for free shipping.`
            : '';
          const qtyCopy = getQuantityCopy(discountItemCount);
          // 未达包邮：免邮与活动文案分行；件数=0 时只提示包邮
          if (underFreeShipping) {
            rewardText = discountItemCount > 0 ? `${shippingPrefix}<br>${qtyCopy}` : shippingPrefix;
          } else {
            rewardText = qtyCopy;
          }
        }

        if (maxoutEle) {
          maxoutEle.innerHTML = rewardText || '';
          maxoutEle.style.display = rewardText ? '' : 'none';
        }
        if(document.querySelector('.cart-recommended') && markup.cartRecommended) {
          markup.cartRecommended.querySelectorAll('.drawer--quick-shop').forEach((item) => {
            // if (!Array.from(document.body.children).find((i) => i.id == item.id) && item.querySelector('.product-section')) {
              document.body.appendChild(item);
            // } else {
            //   item.remove();
            // }
          });
          const obj = {};
          Array.from(document.body.children).forEach((item) => {
            if (item.classList.contains('drawer--quick-shop')) {
              if (!item.querySelector('.product-section') || obj[item.id]) {
                item.remove();
              } else {
                obj[item.id] = true;
              }
            }
          });
          const liveRecommended = document.querySelector('.cart-recommended');
          const liveList = liveRecommended && liveRecommended.querySelector('.cart-recommended__list');
          if (liveList && markup.cartRecommended) {
            const incomingItems = markup.cartRecommended.querySelectorAll('.cart-recommended__item:not(.cart-recommended__item--giftbag)');
            liveList.querySelectorAll('.cart-recommended__item:not(.cart-recommended__item--giftbag)').forEach(function(node) {
              node.remove();
            });
            incomingItems.forEach(function(node) {
              liveList.appendChild(node);
            });
          } else if (markup.cartRecommended) {
            liveRecommended.innerHTML = markup.cartRecommended.innerHTML;
          }
          if (typeof window.themeCartUpsellInit === 'function') {
            window.themeCartUpsellInit(document);
          }
          if (typeof theme.initQuickShop === 'function') {
            theme.initQuickShop();
          }
        }
        // 满额/盲盒推荐卡：移动端 Swiper 会拆成多个 giftbag slide。
        // 盲盒已在车内 → 清空并移除 slide（避免 Swiper 留白）；减掉后再重建。
        (function syncCartGiftBagMarkup() {
          if (!markup.cartGiftBaged) return;
          var liveList = document.querySelector('.cart-recommended .cart-recommended__list, .cart-recommended .swiper-wrapper');
          if (!liveList) return;
          var giftSlides = Array.prototype.slice.call(
            liveList.querySelectorAll(':scope > .cart-recommended__item--giftbag')
          );
          var hasGiftContent = !!markup.cartGiftBaged.querySelector('.giftBag-container');

          if (!hasGiftContent) {
            for (var ri = 0; ri < giftSlides.length; ri++) {
              if (giftSlides[ri].parentNode) {
                giftSlides[ri].parentNode.removeChild(giftSlides[ri]);
              }
            }
            return;
          }

          var hostSlide = giftSlides[0];
          if (!hostSlide) {
            hostSlide = document.createElement('div');
            hostSlide.className = 'swiper-slide cart-recommended__item cart-recommended__item--giftbag';
            liveList.insertBefore(hostSlide, liveList.firstChild);
          }
          var host = hostSlide.querySelector('.product-gif-cart-bag-cart');
          if (!host) {
            host = document.createElement('div');
            host.className = 'product-gif-cart-bag-cart cart-drawer__giftbag';
            hostSlide.appendChild(host);
          }

          for (var gi = 1; gi < giftSlides.length; gi++) {
            if (giftSlides[gi].parentNode) {
              giftSlides[gi].parentNode.removeChild(giftSlides[gi]);
            }
          }
          host.innerHTML = markup.cartGiftBaged.innerHTML;
          hostSlide.removeAttribute('hidden');
        })();

        // 领取卡 DOM 已按最新 cart 更新后再解锁
        theme.cart._priceGiftClaimLock = false;

        syncAutoGifts();

        this.reInit();
        new theme.AjaxProduct();
        if (typeof window.initCartUpsellSwiper === 'function') {
          window.initCartUpsellSwiper(true);
        }
        const selectElements = document.querySelectorAll('.gproduct-item-right select[name="id"]');
        selectElements.forEach(selectElement => {
          selectElement.addEventListener('change', function(event) {
            const selectedOption = event.target.selectedOptions[0]; // 获取选中的 <option>
            const dataSrc = selectedOption && selectedOption.getAttribute('data-src'); // 获取 data-src 属性值
            if (!dataSrc) return;
            const gridProduct = event.target.closest('.grid-product');
            if (!gridProduct) return;
            const productImage = gridProduct.querySelector('.image-wrap image-element img, .image-wrap img, .grid-product__content img');
            if (!productImage) return;
            // data-src 可能是相对路径（旧）或完整 CDN URL（image_url）
            const src = (dataSrc.indexOf('//') === 0 || dataSrc.indexOf('http') === 0)
              ? dataSrc
              : `//www.popilush.com/cdn/shop/${dataSrc}`;
            productImage.src = src;
            productImage.removeAttribute('srcset');
          });
        });
        if (window.AOS) { AOS.refreshHard() }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },
  
      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        // Allow qty === 0 (remove line). Do not use !qty — 0 is falsy and would skip sync.
        if (!key || qty === undefined || qty === null || qty === '') {
          return;
        }
        qty = Number(qty);
        if (isNaN(qty) || qty < 0) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }

        theme.cart.changeItem(key, qty)
          .then(function(cart) {

            const parsedCart = JSON.parse(cart);

            if (parsedCart.status === 422) {
              alert(parsedCart.message);
            } else {
              const updatedItem = parsedCart.items.find(item => item.key === key);

              // Update cartItemsUpdated property on object so we can reference later
              if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                this.cartItemsUpdated = true;
              }

              if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                if (updatedItem.quantity !== qty) {
                }
                // Reset property on object so that checkout button will work as usual
                this.cartItemsUpdated = false;
              }

              if (parsedCart.item_count > 0) {
                this.wrapper.classList.remove('is-empty');
              } else {
                this.wrapper.classList.add('is-empty');
              }
            }

            this.buildCart();

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedCart
              }
            }));
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }

        document.querySelectorAll('.site-nav__cart-bag').forEach(function(bag) {
          bag.classList.toggle('is-filled', count > 0);
        });
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();

  theme.vipCartGuard = (function() {
    var inFlightPromise = null;
    var bound = false;

    function getConfig() {
      return window.themeVipGuardConfig || {};
    }

    function getRestrictedProductIdMap() {
      var csv = (getConfig().restrictedProductIdsCsv || '').toString();
      var map = {};

      if (!csv) return map;

      csv.split(',').forEach(function(token) {
        var id = (token || '').trim();
        if (id) {
          map[id] = true;
        }
      });

      return map;
    }

    function isCustomerUnlocked() {
      return !!getConfig().customerVipUnlocked;
    }

    function isGuardEnabled() {
      if (isCustomerUnlocked()) return false;
      var idMap = getRestrictedProductIdMap();
      return Object.keys(idMap).length > 0;
    }

    function fetchCartJson() {
      var cartJsonUrl = (theme.routes && theme.routes.cart) ? theme.routes.cart : '/cart.js';
      return fetch(cartJsonUrl, {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      }).then(function(res) {
        return res.json();
      });
    }

    function removeRestrictedItemsIfNeeded() {
      if (!isGuardEnabled()) {
        return Promise.resolve();
      }

      if (inFlightPromise) return inFlightPromise;

      inFlightPromise = fetchCartJson()
        .then(function(cart) {
          var idMap = getRestrictedProductIdMap();
          var updates = {};

          (cart.items || []).forEach(function(item) {
            var productId = (item.product_id || '').toString();
            if (idMap[productId]) {
              updates[item.key] = 0;
            }
          });

          if (!Object.keys(updates).length) {
            return;
          }

          var cartPageUrl = (theme.routes && theme.routes.cartPage) ? theme.routes.cartPage : '/cart';
          return fetch(cartPageUrl + '/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          })
            .then(function(res) {
              return res.json();
            })
            .then(function() {
              document.dispatchEvent(new CustomEvent('cart:build'));
            });
        })
        .catch(function() {})
        .finally(function() {
          inFlightPromise = null;
        });

      return inFlightPromise;
    }

    function bind() {
      if (bound) return;
      bound = true;

      document.addEventListener('cart:build', function() {
        removeRestrictedItemsIfNeeded();
      });
    }

    function init() {
      bind();
      removeRestrictedItemsIfNeeded();
    }

    return {
      init: init,
      removeRestrictedItemsIfNeeded: removeRestrictedItemsIfNeeded
    };
  })();
  
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      const footer__newsletter = document.querySelectorAll('.footer-newsletter')
      footer__newsletter.forEach(currentEl => {
        var moduleId = currentEl.getAttribute('aria-controls');
        var container = document.getElementById(moduleId);
        var height = container.querySelector(selectors.moduleInner).offsetHeight;
        var isAutoHeight = container.classList.contains(classes.autoHeight);
        setTransitionHeight(container, height, false, isAutoHeight);
      })
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
      const collection__group = document.querySelector(".collection-sidebar__group [data-collapsible-id=filter-color]")
      if(collection__group){
        collection__group.setAttribute('aria-expanded', true);
      }
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
      // document.querySelectorAll(selectors.trigger).forEach(trigger => {
      //   var moduleIdItem = trigger.getAttribute('aria-controls');
      //   if(moduleIdItem.includes('Product-content')){
      //     var containerItem = document.getElementById(moduleIdItem);
      //     var isAutoHeightItem = containerItem.classList.contains(classes.autoHeight);
      //     trigger.setAttribute('aria-expanded', false);
      //     trigger.classList.remove(classes.open);
      //     setTransitionHeight(containerItem, 0, false, isAutoHeightItem);
      //   }
      // });
      isTransitioning = true;
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;

        // PL/移动端导航栏：嵌套三级展开时同步父级高度，避免 overflow:hidden 裁切（仅 NavDrawer）
        if (parentCollapsibleEl.closest('#NavDrawer')) {
          var parentIsAutoHeight = parentCollapsibleEl.classList.contains(classes.autoHeight);
          setTransitionHeight(parentCollapsibleEl, totalHeight, false, parentIsAutoHeight);
        }
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {
  
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._updateListAccessibility(false);
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
        this._updateListAccessibility(false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
        this._updateListAccessibility(!ariaExpanded);
      },

      _updateListAccessibility: function(isVisible) {
        this.cache.disclosureList.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          if (isVisible) {
            if (disclosureOption.dataset.disclosureTabindexBackup !== undefined) {
              if (disclosureOption.dataset.disclosureTabindexBackup === '') {
                disclosureOption.removeAttribute('tabindex');
              } else {
                disclosureOption.setAttribute('tabindex', disclosureOption.dataset.disclosureTabindexBackup);
              }
              delete disclosureOption.dataset.disclosureTabindexBackup;
            }
          } else if (disclosureOption.dataset.disclosureTabindexBackup === undefined) {
            disclosureOption.dataset.disclosureTabindexBackup = disclosureOption.getAttribute('tabindex') || '';
            disclosureOption.setAttribute('tabindex', '-1');
          }
        });
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });
        if (!this.drawer.parentElement && this.drawer.id) {
          this.drawer = document.getElementById(this.drawer.id);
        }
  
        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
        if (!this.drawer.parentElement && this.drawer.id) {
          this.drawer = document.getElementById(this.drawer.id);
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
          const test = window.location.pathname;
          const index = test.lastIndexOf("\/");
          const page_category = test.slice(1,index) || 'Home'
          const page_name = test.substring(index + 1,test.length) || 'Home'
          var first_navi_category = $(this)[0]?.config.id
          window.dataLayer.push({
            event: "first_navi_click",
            first_navi_category: first_navi_category,
            page_category: page_category,
            page_name: page_name
          });
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }
        if (!this.drawer.parentElement && this.drawer.id) {
          this.drawer = document.getElementById(this.drawer.id);
        }
  
        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          } else if (evt.target.closest('#special-offer-popup')) {
            return;
          }
        }
  
        // deselect any focused form elements
        document.activeElement.blur();
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
  
        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);

      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        const test = window.location.pathname;
        const index = test.lastIndexOf("\/");
        const page_category = test.slice(1,index) || 'Home'
        const page_name = test.substring(index + 1,test.length) || 'Home'
        var product_name = $(this)[0].modal.dataset.title
        var product_id = $(this)[0].modal.dataset.productId
        var product_value = $(this)[0].modal.dataset.price
        var product_currency = window.Shopify.currency?.active
        window.dataLayer.push({
          event: "quick_view_item",
          product_name: product_name,
          product_id: product_id,
          product_value:product_value,
          product_currency:product_currency,
          page_category: page_category,
          page_name: page_name
        });
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);
  
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  /*============================================================================
    ParallaxImage
  ==============================================================================*/
  
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [  1,  0 ],
        90: [  0, -1 ],
        180: [ -1,  0 ],
        270: [  0,  1 ]
      }
  
      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }
  
    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;
  
      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));
  
      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);
  
      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px
  
      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360
  
      const toLeft = angle > 90 && angle < 270;
      const toTop  = angle < 180;
  
      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop  ? 'top' : 'bottom'] = 0;
  
      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [ Math.cos(radians), Math.sin(radians) * -1 ] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }
  
      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width  = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${Math.abs(multipliers[1])}px)`;
  
      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }
  
    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;
  
      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;
  
      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${multipliers[1]}px, 0)`;
      }
  
      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }
  
    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }
  
      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }
  
  customElements.define('parallax-image', ParallaxImage);
  
  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }
  
  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };
  
    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};
  
      return this.init();
    }
  
    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }
  
        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
  
        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
  
        return this.createPriceRange();
      },
  
      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }
  
        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });
  
        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );
  
          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });
  
        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];
  
          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            let sortBy = params.getAll('sort_by');
            let colors = params.getAll('filter.v.option.color').join(',');
            let size = params.getAll('filter.v.option.size').join(',');
            const priceGte = params.get('filter.v.price.gte');
            const priceLte = params.get('filter.v.price.lte');
            window.dataLayer.push({
              event: "filter",
              color: colors,
              size: size,
              price: `From ${priceGte} to ${priceLte}`,
              sort_by: sortBy,
            });
          }
        });
  
        return slider;
      },
    });
  
    return PriceRange;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm(form, submit, args) {
      if (document.querySelector('[data-product-blocks]')?.querySelector('[data-add-to-cart]')) {
        var __atcInit = document.querySelector('[data-product-blocks]').querySelector('[data-add-to-cart]');
        __atcInit.classList.remove('btn--loading');
        if (!__atcInit.hasAttribute('data-vip-cart-locked')) {
          __atcInit.removeAttribute('disabled');
        }
      }
      document.addEventListener('click', (event) => {
        const clickedElement = event.target;
        const isButtonATC = clickedElement?.matches('[data-add-to-cart]');
        const isButtonATCPopup = clickedElement?.matches('[data-add-to-cart-popup]');
        const getButtonATC = clickedElement?.closest('[data-add-to-cart]');
        const isButtonATCPopup2 = clickedElement?.closest('[data-add-to-cart-popup]');
        const haPopup = clickedElement?.closest('[has-popup]');
        const popup = document.getElementById('special-offer-popup');
        const overlay = document.getElementById('special-offer-overlay');

        if (isButtonATC || getButtonATC) {
          var atcBtn = getButtonATC || (isButtonATC ? clickedElement : null);
          if (atcBtn && (atcBtn.hasAttribute('data-vip-cart-locked') || atcBtn.disabled)) {
            event.preventDefault();
            return;
          }
          if (atcBtn && atcBtn.closest('#CartDrawer')) {
            var upsellCard = atcBtn.closest('.gproduct-item-container');
            var upsellSelect = upsellCard && upsellCard.querySelector('select.gproduct-item-sizes[data-cart-upsell="true"]');
            if (upsellSelect && !upsellSelect.value) {
              event.preventDefault();
              event.stopPropagation();
              return;
            }
          }
          var priceGiftClaim = atcBtn && atcBtn.closest('[data-price-gift-claim="true"]');
          if (priceGiftClaim && theme.cart._priceGiftClaimLock) {
            event.preventDefault();
            return;
          }
          if (priceGiftClaim) {
            var giftProductId = priceGiftClaim.getAttribute('data-gift-product-id');
            if (
              giftProductId &&
              document.querySelector('.cart__items [data-product-id="' + giftProductId + '"]')
            ) {
              event.preventDefault();
              document.dispatchEvent(new CustomEvent('cart:build'));
              return;
            }
          }
          event.preventDefault();
          // Cart Drawer Buy It With：必须用当前点击的按钮，不能 form.querySelector 取第一张卡
          this.addToCart = atcBtn;
          this.form = atcBtn.closest('form');
          if (this.addToCart && this.form) {
            this.addItemFromForm();
          }
        }
        if(isButtonATCPopup || isButtonATCPopup2) {
          // 显示预渲染的弹窗
          if(!document.querySelector('.special-item')) {
            if (popup && overlay) {
              popup.style.display = 'block';
              overlay.style.display = 'block';
              
              // 关闭弹窗
              popup.querySelector('#close-popup').addEventListener('click', () => {
                popup.style.display = 'none';
                overlay.style.display = 'none';
              });
            }
          }
        }
        if(haPopup) {
          popup.style.display = 'none';
          overlay.style.display = 'none';
        }
      })

      this.args = args;
  
    };
  
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        // evt.preventDefault();
        if (status.loading) {
          return;
        }

        var isPriceGiftClaim = !!(this.form && this.form.closest('[data-price-gift-claim="true"]'));
        if (isPriceGiftClaim) {
          if (theme.cart._priceGiftClaimLock) {
            return;
          }
          theme.cart._priceGiftClaimLock = true;
          document.querySelectorAll('[data-price-gift-claim="true"] [data-add-to-cart]').forEach(function(btn) {
            btn.setAttribute('disabled', 'disabled');
          });
        }
  
        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');
        status.loading = true;
        // 获取按钮上的 data-bundlevariantid
        const bundleVariantId = this.addToCart.dataset.bundlevariantid;
        const bundleVariantStr = this.addToCart.dataset.bundlevariantstr;
        if (bundleVariantId) {
          // 检查表单内是否已有相同的字段
          let existingInput = this.form.querySelector('input[name="properties[__bundle_children]"]');
          if (!existingInput) {
            existingInput = document.createElement('input');
            existingInput.type = 'hidden';
            existingInput.name = 'properties[__bundle_children]';
            this.form.appendChild(existingInput);
          }
          const variantIds = bundleVariantId.split(',').filter(e=>e);
          existingInput.value = JSON.stringify(
              variantIds.map(variant_id => ({ variant_id }))
          );
        }
        if (bundleVariantStr) {
          let inputVariantStr = this.form.querySelector('input[name="properties[__bundlevariantstr]"]');
          if (!inputVariantStr) {
            inputVariantStr = document.createElement('input');
            inputVariantStr.type = 'hidden';
            inputVariantStr.name = 'properties[__bundlevariantstr]';
            this.form.appendChild(inputVariantStr);
          }
          inputVariantStr.value = bundleVariantStr;
        }

        // Cart Drawer Buy It With / 盲盒：嵌套在 #CartDrawerForm 内时 serialize 拿不到 Size 的 id，
        // 直接读卡片上的 variant select 组装 payload。
        var data;
        var upsellCard = this.addToCart && this.addToCart.closest('#CartDrawer .gproduct-item-container');
        var upsellSizeSelect = upsellCard && upsellCard.querySelector('select.gproduct-item-sizes[name="id"]');
        if (upsellSizeSelect && upsellSizeSelect.value) {
          data = 'id=' + encodeURIComponent(upsellSizeSelect.value) + '&quantity=1';
        } else {
          data = theme.utils.serialize(this.form);
        }
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
            if (isPriceGiftClaim) {
              theme.cart._priceGiftClaimLock = false;
              document.querySelectorAll('[data-price-gift-claim="true"] [data-add-to-cart]').forEach(function(btn) {
                btn.removeAttribute('disabled');
              });
            }
          } else {
            var product = data;
            this.success(product);
            // 满额赠：保持 lock 直到 cart:build 完成，避免藏卡前再次加购
          }
          status.loading = false;
          this.addToCart.classList.remove('btn--loading');
  
          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this))
        .catch(function() {
          status.loading = false;
          if (this.addToCart) {
            this.addToCart.classList.remove('btn--loading');
          }
          if (isPriceGiftClaim) {
            theme.cart._priceGiftClaimLock = false;
            document.querySelectorAll('[data-price-gift-claim="true"] [data-add-to-cart]').forEach(function(btn) {
              btn.removeAttribute('disabled');
            });
          }
        }.bind(this));
      },
  
      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        if (theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
        }
        
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },
  
      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }
  
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        if (this.form && this.form.closest('#CartDrawer')) {
          errorDiv.classList.add('errors--cart-drawer-upsell');
        }

        if (typeof error.description === 'object') {
          errorDiv.textContent = error.message;
        } else {
          errorDiv.textContent = error.description;
        }

        this.form.append(errorDiv);
  
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });
  
    return ProductForm;
  })();

  class ProudctForm extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector('[data-add-to-cart]')) {
        var __atcEl = this.querySelector('[data-add-to-cart]');
        __atcEl?.classList?.remove('btn--loading');
        if (!__atcEl?.hasAttribute('data-vip-cart-locked')) {
          __atcEl?.removeAttribute('disabled');
        }
      }
    }
  }
  customElements.define('product-form', ProudctForm);
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function(event) {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        if (!event.detail.autoplayMedia) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  
  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          if (this._isGiftQtyLocked()) {
            return;
          }
          var qty = this._getQty();
          var boxType = this.input.dataset?.lihebox;
          var limit = Number(this.input.dataset?.giftbagcount);
          if (["liHeBox", "liHeBox2", "liHeBox3", "liHeBox4", "liHeBox5", "liHeBox6", "liHeBox7"].includes(boxType)) {
            if (qty >= limit) {
              this._change(qty);
            } else {
              this._change(qty + 1);
            }
          } else {
            this._change(qty + 1);
          }

        }.bind(this));

        this.minus.addEventListener('click', function() {
          if (this._isGiftQtyLocked()) {
            return;
          }
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));

        this.input.addEventListener('change', function(evt) {
          if (this._isGiftQtyLocked()) {
            this.input.value = this.input.defaultValue;
            return;
          }
          var boxType = this.input.dataset?.lihebox;
          if (["liHeBox", "liHeBox2", "liHeBox3", "liHeBox4", "liHeBox5", "liHeBox6", "liHeBox7"].includes(boxType)) {
            this._change(this._getQty('count'));
          } else {
            this._change(this._getQty());
          }
        }.bind(this));
      },
      _isGiftQtyLocked: function() {
        return this.input && this.input.getAttribute('data-gift-qty-locked') === 'true';
      },
      _getQty: function(count) {
        var qty = this.input.value;
        var productQuantityElement = document.querySelector('.product__quantity_num');
        if (productQuantityElement) {
          productQuantityElement.innerText = qty;
        }
        if(count) {
          if(qty > Number(this.input.dataset?.giftbagcount)) {
            qty = Number(this.input.dataset?.giftbagcount);
          }
        } else {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        }

        return parseInt(qty);
      },
  
      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });
  
    return QtySelector;
  })();
  
  theme.initCollectionSizeBar = function() {
    var collectionSection = document.querySelector('[data-section-type="collection-grid"][data-collection-handle="best-seller"]');
    if (!collectionSection) {
      return;
    }

    // PC only — 尺码条 / 色块锁定主图；移动端逻辑不改动
    if (theme.config.bpSmall || window.innerWidth <= 768) {
      return;
    }

    // PC best-seller：色块点击阻止 <a> 跳转（仅 preventDefault，不中断后续锁定逻辑）
    if (collectionSection.dataset.swatchNavBlocked !== 'true') {
      collectionSection.dataset.swatchNavBlocked = 'true';
      collectionSection.addEventListener('click', function(evt) {
        if (theme.config.bpSmall || window.innerWidth <= 768) {
          return;
        }

        var swatch = evt.target.closest('.grid-product__colors .color-swatch, .grid-product__colors .bundle-link-cus');
        if (!swatch || !collectionSection.contains(swatch)) {
          return;
        }
        evt.preventDefault();
      }, true);
    }

    var loadingMap = collectionSection._collectionSizeBarLoadingMap || (collectionSection._collectionSizeBarLoadingMap = {});

    function getOptionValue(variant, index) {
      if (index === 0) return variant.option1;
      if (index === 1) return variant.option2;
      if (index === 2) return variant.option3;
      return variant.options ? variant.options[index] : null;
    }

    function getProductVariants(product) {
      if (product._collectionSizeVariants) {
        return product._collectionSizeVariants;
      }

      var variantsScript = product.querySelector('[data-collection-size-variants]');
      if (!variantsScript) {
        return null;
      }

      try {
        product._collectionSizeVariants = JSON.parse(variantsScript.textContent);
        return product._collectionSizeVariants;
      } catch (error) {
        return null;
      }
    }

    function findVariant(variants, colorOptionIndex, sizeOptionIndex, colorValue, sizeValue) {
      return variants.find(function(variant) {
        if (colorOptionIndex !== null && getOptionValue(variant, colorOptionIndex) !== colorValue) {
          return false;
        }
        return getOptionValue(variant, sizeOptionIndex) === sizeValue;
      });
    }

    function getActiveColorValue(product, sizeBar, variants, colorOptionIndex) {
      if (colorOptionIndex === null) {
        return '';
      }

      var activeColorEl = product.querySelector('.grid-product__color-image.is-active');
      if (activeColorEl) {
        var classNames = activeColorEl.className.split(/\s+/);
        var variantId = null;
        classNames.forEach(function(className) {
          var match = className.match(/^grid-product__color-image--(\d+)$/);
          if (match) {
            variantId = match[1];
          }
        });

        if (variantId) {
          var activeVariant = variants.find(function(variant) {
            return String(variant.id) === String(variantId);
          });
          if (activeVariant) {
            return getOptionValue(activeVariant, colorOptionIndex);
          }
        }
      }

      return sizeBar.dataset.activeColor || sizeBar.dataset.defaultColor || '';
    }

    function getSwatchColorValue(swatch, colorOptionIndex) {
      if (swatch.dataset.variantId) {
        return null;
      }

      var ariaLabel = swatch.getAttribute('aria-label') || '';
      var parts = ariaLabel.split(' - ');
      if (parts.length > 1) {
        return parts[parts.length - 1].trim();
      }

      return null;
    }

    function syncSizeBarFromSwatch(product, swatch) {
      var sizeBar = product.querySelector('[data-collection-size-bar]');
      var variants = getProductVariants(product);
      if (!sizeBar || !variants) {
        return;
      }

      var colorOptionIndex = sizeBar.dataset.colorOptionIndex;
      colorOptionIndex = colorOptionIndex === undefined || colorOptionIndex === '' ? null : parseInt(colorOptionIndex, 10);
      if (colorOptionIndex === null) {
        return;
      }

      if (swatch.dataset.variantId) {
        var variant = variants.find(function(item) {
          return String(item.id) === String(swatch.dataset.variantId);
        });
        if (variant) {
          updateSizeButtons(product, getOptionValue(variant, colorOptionIndex));
        }
        return;
      }

      var swatchColor = getSwatchColorValue(swatch, colorOptionIndex);
      if (swatchColor) {
        updateSizeButtons(product, swatchColor);
      }
    }

    function clearProductColorImages(product) {
      product.querySelectorAll('.grid-product__color-image').forEach(function(el) {
        el.classList.remove('is-active');
        el.style.opacity = '';
        el.style.zIndex = '';
        el.style.clipPath = '';
        el.style.transform = '';
      });
    }

    function showProductColorImage(product, variantId, imageUrl) {
      var imageEl = product.querySelector('.grid-product__color-image--' + variantId);
      if (!imageEl || !imageUrl) {
        return false;
      }

      var current = product.querySelector('.grid-product__color-image.is-active');
      if (current === imageEl) {
        return true;
      }

      imageEl.style.backgroundImage = 'url(' + imageUrl + ')';
      imageEl.classList.add('is-active');
      imageEl.style.opacity = '1';
      imageEl.style.zIndex = '3';

      // Shapellx collection 同款：clip-path 擦拭翻页 + 轻微位移
      var wipeKeyframes = [
        {
          clipPath: 'polygon(0 0, 0 0, 0 100%, 0% 100%)',
          transform: 'translateX(-20px)',
          offset: 0
        },
        {
          clipPath: 'polygon(0 0, 20% 0, 5% 100%, 0 100%)',
          transform: 'translateX(-20px)',
          offset: 0.3
        },
        {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          transform: 'translateX(0px)',
          offset: 1
        }
      ];

      function finishWipe() {
        // PERF-BS-003: 动画结束清除临时 will-change，避免常驻合成层
        imageEl.style.clipPath = '';
        imageEl.style.transform = '';
        imageEl.style.zIndex = '';
        imageEl.style.willChange = '';
        product.querySelectorAll('.grid-product__color-image').forEach(function(el) {
          if (el !== imageEl) {
            el.classList.remove('is-active');
            el.style.opacity = '';
            el.style.zIndex = '';
            el.style.clipPath = '';
            el.style.transform = '';
            el.style.willChange = '';
          }
        });
        product._colorWipeAnim = null;
      }

      if (product._colorWipeAnim && typeof product._colorWipeAnim.cancel === 'function') {
        try {
          product._colorWipeAnim.cancel();
        } catch (error) {}
      }

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion && typeof imageEl.animate === 'function') {
        // PERF-BS-003: 仅在 wipe 期间开启 will-change
        imageEl.style.willChange = 'clip-path, transform';
        var anim = imageEl.animate(wipeKeyframes, {
          duration: 500,
          easing: 'ease-in-out',
          fill: 'forwards'
        });
        product._colorWipeAnim = anim;
        anim.finished.then(finishWipe).catch(finishWipe);
      } else {
        finishWipe();
      }

      return true;
    }

    function setLockedSwatchUI(product, lockedSwatch) {
      product.querySelectorAll('.grid-product__colors .color-swatch, .grid-product__colors .bundle-link-cus').forEach(function(el) {
        el.classList.toggle('is-active', el === lockedSwatch);
      });
    }

    function bindCollectionColorSwatchLock() {
      if (collectionSection.dataset.colorLockBound === 'true') {
        return;
      }
      collectionSection.dataset.colorLockBound = 'true';

      // 冒泡阶段：锁定主图，并阻止冒泡到商品卡其它 click
      collectionSection.addEventListener('click', function(evt) {
        if (theme.config.bpSmall || window.innerWidth <= 768) {
          return;
        }

        var swatch = evt.target.closest('.grid-product__colors .color-swatch, .grid-product__colors .bundle-link-cus');
        if (!swatch || !collectionSection.contains(swatch)) {
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        var product = swatch.closest('.grid-product');
        if (!product) {
          return;
        }

        // PERF-BS-002: 点色块时按需初始化该卡
        ensureProductCollectionReady(product);

        var variantId = swatch.dataset.variantId;
        // PERF-BS-005: 优先用图集同色首图（与箭头同源 400x），否则回退 data-variant-image
        var imageUrl = swatch.dataset.variantImage || '';
        var colorValue = swatch.dataset.colorValue || '';
        if (colorValue) {
          var galleries = getProductColorGalleries(product);
          var galleryEntry = galleries[colorValue];
          if (galleryEntry && galleryEntry.urls && galleryEntry.urls.length) {
            imageUrl = galleryEntry.urls[0];
            if (!variantId && galleryEntry.variantId) {
              variantId = String(galleryEntry.variantId);
            }
          }
        }

        var imageEl = variantId
          ? product.querySelector('.grid-product__color-image--' + variantId)
          : null;

        // 有图：锁定主图（Shapellx 式 clip-path 翻页）；无图：保持原图，仅同步尺码条
        if (variantId && imageUrl && imageEl) {
          hideGalleryStage(product);
          product.dataset.lockedColorVariantId = variantId;
          if (colorValue) {
            product.dataset.lockedColorValue = colorValue;
          }
          product._colorGalleryIndex = 0;
          showProductColorImage(product, variantId, imageUrl);
          setLockedSwatchUI(product, swatch);
          refreshColorGalleryNav(product);
        }

        syncSizeBarFromSwatch(product, swatch);

        // 去掉色块焦点，避免整卡 :focus-within 误显尺码条 / Ship in 24 hrs
        if (typeof swatch.blur === 'function') {
          swatch.blur();
        }
      });
    }

    function getColorGalleryPayload(product) {
      if (product._colorGalleryPayload) {
        return product._colorGalleryPayload;
      }

      var script = product.querySelector('[data-collection-color-galleries]');
      if (!script) {
        return null;
      }

      try {
        product._colorGalleryPayload = JSON.parse(script.textContent);
        return product._colorGalleryPayload;
      } catch (error) {
        return null;
      }
    }

    function buildColorGalleries(payload) {
      if (!payload || !payload.media || !payload.colorStarts) {
        return {};
      }

      var media = payload.media;
      var starts = payload.colorStarts
        .map(function(item) {
          var index = -1;
          for (var i = 0; i < media.length; i++) {
            if (String(media[i].id) === String(item.mediaId)) {
              index = i;
              break;
            }
          }
          if (index < 0 && item.src) {
            for (var j = 0; j < media.length; j++) {
              if (media[j].src && (media[j].src === item.src || media[j].src.indexOf(item.src.split('?')[0]) === 0 || item.src.indexOf(media[j].src.split('?')[0]) === 0)) {
                index = j;
                break;
              }
            }
          }
          return {
            color: item.color,
            variantId: item.variantId,
            index: index,
            src: item.src || ''
          };
        })
        .filter(function(item) {
          return item.index >= 0 || item.src;
        })
        .map(function(item) {
          if (item.index < 0 && item.src) {
            // featured 未匹配到 media 列表时，至少保留主图
            return item;
          }
          return item;
        })
        .sort(function(a, b) {
          var ai = a.index < 0 ? 9999 : a.index;
          var bi = b.index < 0 ? 9999 : b.index;
          return ai - bi;
        });

      var galleries = {};
      starts.forEach(function(start, i) {
        var urls = [];
        if (start.index >= 0) {
          var end = media.length;
          for (var n = i + 1; n < starts.length; n++) {
            if (starts[n].index >= 0) {
              end = starts[n].index;
              break;
            }
          }
          for (var m = start.index; m < end; m++) {
            if (media[m] && media[m].src) {
              urls.push(media[m].src);
            }
          }
        } else if (start.src) {
          urls.push(start.src);
        }
        if (urls.length) {
          galleries[start.color] = {
            urls: urls,
            variantId: start.variantId
          };
        }
      });
      return galleries;
    }

    function getProductColorGalleries(product) {
      if (product._colorGalleries) {
        return product._colorGalleries;
      }
      var payload = getColorGalleryPayload(product);
      product._colorGalleries = buildColorGalleries(payload);
      product._colorGalleryDefault = payload && payload.defaultColor ? payload.defaultColor : '';
      return product._colorGalleries;
    }

    function resolveCurrentColorKey(product, galleries) {
      var locked = product.dataset.lockedColorValue;
      if (locked && galleries[locked]) {
        return locked;
      }

      var sizeBar = product.querySelector('[data-collection-size-bar]');
      var active = sizeBar && (sizeBar.dataset.activeColor || sizeBar.dataset.defaultColor);
      if (active && galleries[active]) {
        return active;
      }

      if (product._colorGalleryDefault && galleries[product._colorGalleryDefault]) {
        return product._colorGalleryDefault;
      }

      var keys = Object.keys(galleries);
      return keys.length ? keys[0] : '';
    }

    function findSwatchByColor(product, colorKey) {
      var matched = null;
      product.querySelectorAll('.grid-product__colors [data-color-value]').forEach(function(el) {
        if (!matched && el.dataset.colorValue === colorKey) {
          matched = el;
        }
      });
      return matched;
    }

    function refreshColorGalleryNav(product) {
      var nav = product.querySelector('[data-collection-image-nav]');
      if (!nav) {
        return;
      }

      var galleries = getProductColorGalleries(product);
      var colorKey = resolveCurrentColorKey(product, galleries);
      var entry = colorKey ? galleries[colorKey] : null;
      var ready = !!(entry && entry.urls && entry.urls.length > 1);

      nav.hidden = !ready;
      nav.classList.toggle('is-ready', ready);
      if (ready) {
        product.dataset.galleryColorKey = colorKey;
        if (typeof product._colorGalleryIndex !== 'number') {
          product._colorGalleryIndex = 0;
        }
      }
    }

    function findColorImageLayer(product, variantId, colorKey) {
      var imageEl = variantId
        ? product.querySelector('.grid-product__color-image--' + variantId)
        : null;
      if (imageEl) {
        return imageEl;
      }

      var swatch = findSwatchByColor(product, colorKey);
      if (swatch && swatch.dataset.variantId) {
        imageEl = product.querySelector('.grid-product__color-image--' + swatch.dataset.variantId);
        if (imageEl) {
          product.dataset.lockedColorVariantId = swatch.dataset.variantId;
          return imageEl;
        }
      }

      return product.querySelector('.grid-product__color-image');
    }

    function ensureColorImageLayer(product, variantId, url, colorKey) {
      var imageEl = findColorImageLayer(product, variantId, colorKey);
      if (!imageEl || !url) {
        return null;
      }

      imageEl.style.backgroundImage = 'url(' + url + ')';
      product.querySelectorAll('.grid-product__color-image').forEach(function(el) {
        if (el !== imageEl) {
          el.classList.remove('is-active');
          el.style.opacity = '';
          el.style.zIndex = '';
        }
      });
      imageEl.classList.add('is-active');
      imageEl.style.opacity = '1';
      imageEl.style.zIndex = '3';
      return imageEl;
    }

    function suppressSecondaryImage(product, suppress) {
      var secondary = product.querySelector('.grid-product__secondary-image');
      if (!secondary) {
        return;
      }
      if (suppress) {
        secondary.style.animation = 'none';
        secondary.style.opacity = '0';
        secondary.style.visibility = 'hidden';
      } else {
        secondary.style.animation = '';
        secondary.style.opacity = '';
        secondary.style.visibility = '';
      }
    }

    function preloadGalleryUrl(url) {
      return new Promise(function(resolve) {
        if (!url) {
          resolve();
          return;
        }
        var img = new Image();
        img.onload = function() {
          if (img.decode) {
            img.decode().then(resolve).catch(resolve);
          } else {
            resolve();
          }
        };
        img.onerror = function() { resolve(); };
        img.src = url;
      });
    }

    function hideGalleryStage(product) {
      var stage = product.querySelector('[data-collection-gallery-stage]');
      var mask = product.querySelector('.grid-product__image-mask');
      if (stage) {
        stage.classList.remove('is-visible');
        stage.setAttribute('aria-hidden', 'true');
      }
      if (mask) {
        mask.classList.remove('is-gallery-showing');
      }
      suppressSecondaryImage(product, false);
    }

    function showGalleryStageImage(product, url) {
      var stage = product.querySelector('[data-collection-gallery-stage]');
      var img = product.querySelector('[data-collection-gallery-img]');
      var mask = product.querySelector('.grid-product__image-mask');
      if (!stage || !img || !url) {
        return Promise.resolve(null);
      }

      return preloadGalleryUrl(url).then(function() {
        img.src = url;
        var reveal = function() {
          stage.classList.add('is-visible');
          stage.setAttribute('aria-hidden', 'false');
          if (mask) {
            mask.classList.add('is-gallery-showing');
          }
          return img;
        };
        if (img.decode) {
          return img.decode().then(reveal).catch(reveal);
        }
        return reveal();
      });
    }

    function stepColorGallery(product, direction) {
      // PERF-BS-002: 点箭头时按需初始化该卡
      ensureProductCollectionReady(product);

      var galleries = getProductColorGalleries(product);
      var colorKey = resolveCurrentColorKey(product, galleries);
      var entry = colorKey ? galleries[colorKey] : null;
      if (!entry || !entry.urls || entry.urls.length < 2) {
        return;
      }

      var len = entry.urls.length;
      var index = typeof product._colorGalleryIndex === 'number' ? product._colorGalleryIndex : 0;
      var nextIndex = (index + direction + len) % len;
      var nextUrl = entry.urls[nextIndex];

      showGalleryStageImage(product, nextUrl).then(function() {
        product._colorGalleryIndex = nextIndex;
        product.dataset.lockedColorValue = colorKey;
        product.dataset.galleryColorKey = colorKey;
        if (entry.variantId) {
          product.dataset.lockedColorVariantId = String(entry.variantId);
        }

        // 静默同步色图层，移出后仍停在当前角度；不参与本次显示，避免抢显闪跳
        var colorEl = findColorImageLayer(product, entry.variantId, colorKey);
        if (colorEl) {
          colorEl.style.backgroundImage = 'url(' + nextUrl + ')';
          product.querySelectorAll('.grid-product__color-image').forEach(function(el) {
            el.classList.toggle('is-active', el === colorEl);
          });
        }

        var swatch = findSwatchByColor(product, colorKey);
        if (swatch) {
          setLockedSwatchUI(product, swatch);
          syncSizeBarFromSwatch(product, swatch);
        }
        refreshColorGalleryNav(product);
      });
    }

    function bindCollectionColorGalleryNav() {
      if (collectionSection.dataset.colorGalleryNavBound === 'true') {
        return;
      }
      collectionSection.dataset.colorGalleryNavBound = 'true';

      function isGalleryNavTarget(target) {
        return !!(target && target.closest && target.closest('[data-collection-image-prev], [data-collection-image-next]'));
      }

      function blockNavEvent(evt) {
        if (theme.config.bpSmall || window.innerWidth <= 768) {
          return false;
        }
        if (!isGalleryNavTarget(evt.target)) {
          return false;
        }
        evt.preventDefault();
        evt.stopPropagation();
        if (typeof evt.stopImmediatePropagation === 'function') {
          evt.stopImmediatePropagation();
        }
        return true;
      }

      // 捕获阶段拦截，避免点箭头触发商品链接进详情
      ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function(type) {
        collectionSection.addEventListener(type, function(evt) {
          if (!blockNavEvent(evt)) {
            return;
          }
          if (type === 'click') {
            var product = evt.target.closest('.grid-product');
            if (!product) {
              return;
            }
            var nextBtn = evt.target.closest('[data-collection-image-next]');
            stepColorGallery(product, nextBtn ? 1 : -1);
          }
        }, true);
      });

      collectionSection.addEventListener('mouseout', function(evt) {
        var mask = evt.target.closest('.grid-product__image-mask');
        if (!mask || !collectionSection.contains(mask)) {
          return;
        }
        if (evt.relatedTarget && mask.contains(evt.relatedTarget)) {
          return;
        }
        var product = mask.closest('.grid-product');
        if (product) {
          hideGalleryStage(product);
        }
      });

      collectionSection.addEventListener('mouseenter', function(evt) {
        var mask = evt.target.closest('.grid-product__image-mask');
        if (!mask || !collectionSection.contains(mask)) {
          return;
        }
        var product = mask.closest('.grid-product');
        if (!product) {
          return;
        }
        ensureProductCollectionReady(product);
        var galleries = getProductColorGalleries(product);
        var colorKey = resolveCurrentColorKey(product, galleries);
        var entry = colorKey ? galleries[colorKey] : null;
        if (!entry || !entry.urls || entry.urls.length < 2) {
          return;
        }
        var len = entry.urls.length;
        var index = typeof product._colorGalleryIndex === 'number' ? product._colorGalleryIndex : 0;
        preloadGalleryUrl(entry.urls[(index + 1) % len]);
        preloadGalleryUrl(entry.urls[(index - 1 + len) % len]);
      }, true);
    }

    function updateSizeButtons(product, forcedColor) {
      var sizeBar = product.querySelector('[data-collection-size-bar]');
      var variants = getProductVariants(product);
      if (!sizeBar || !variants) {
        return;
      }

      var sizeOptionIndex = parseInt(sizeBar.dataset.sizeOptionIndex, 10);
      var colorOptionIndex = sizeBar.dataset.colorOptionIndex;
      colorOptionIndex = colorOptionIndex === undefined || colorOptionIndex === '' ? null : parseInt(colorOptionIndex, 10);
      var activeColor = forcedColor !== undefined && forcedColor !== null
        ? forcedColor
        : getActiveColorValue(product, sizeBar, variants, colorOptionIndex);
      sizeBar.dataset.activeColor = activeColor;

      product.querySelectorAll('.collection-size-bar__btn').forEach(function(button) {
        var sizeValue = button.dataset.sizeValue;
        var variant = findVariant(variants, colorOptionIndex, sizeOptionIndex, activeColor, sizeValue);
        var isAvailable = variant && variant.available;

        button.classList.toggle('is-disabled', !isAvailable);
        button.disabled = !isAvailable;
        if (isAvailable) {
          button.removeAttribute('aria-disabled');
          button.dataset.variantId = variant.id;
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('data-variant-id');
        }
      });
    }

    // PERF-BS-002: 单卡首次交互再 parse JSON / 更新尺码 / 计算箭头，避免首屏全量跑
    function ensureProductCollectionReady(product) {
      if (!product || product._collectionInteractiveReady) {
        return;
      }
      product._collectionInteractiveReady = true;

      if (product.querySelector('[data-collection-size-bar]')) {
        updateSizeButtons(product);
      }
      refreshColorGalleryNav(product);
    }

    function openCartAfterAdd(form, productData) {
      if (theme.settings.cartType === 'page') {
        window.location = theme.routes.cartPage;
        return;
      }

      var eventDetail = {
        detail: {
          product: productData
        },
        bubbles: true
      };

      form.dispatchEvent(new CustomEvent('ajaxProduct:added', eventDetail));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', eventDetail));
      document.dispatchEvent(new CustomEvent('cart:open'));
    }

    function addVariantToCart(product, sizeBar, form, button, variant) {
      var productId = product.dataset.productId;
      if (loadingMap[productId]) {
        return;
      }

      var idInput = form.querySelector('[name="id"]');
      loadingMap[productId] = true;
      button.classList.add('is-loading');
      idInput.value = variant.id;

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: 'id=' + encodeURIComponent(variant.id) + '&quantity=1',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.status === 422) {
          window.alert(data.description || data.message || 'Unable to add to cart');
          return;
        }

        openCartAfterAdd(form, data);
      })
      .catch(function(error) {
        console.warn(error);
      })
      .finally(function() {
        loadingMap[productId] = false;
        button.classList.remove('is-loading');
      });
    }

    if (collectionSection.dataset.sizeBarDelegationBound !== 'true') {
      collectionSection.dataset.sizeBarDelegationBound = 'true';

      collectionSection.addEventListener('mouseover', function(evt) {
        var swatch = evt.target.closest('.grid-product__colors .color-swatch, .grid-product__colors .bundle-link-cus');
        if (!swatch) {
          return;
        }

        var product = swatch.closest('.grid-product');
        if (!product) {
          return;
        }

        ensureProductCollectionReady(product);

        var sizeBar = product.querySelector('[data-collection-size-bar]');
        var variants = getProductVariants(product);
        if (!sizeBar || !variants) {
          return;
        }

        var colorOptionIndex = sizeBar.dataset.colorOptionIndex;
        colorOptionIndex = colorOptionIndex === undefined || colorOptionIndex === '' ? null : parseInt(colorOptionIndex, 10);
        if (colorOptionIndex === null) {
          return;
        }

        if (swatch.dataset.variantId) {
          var variant = variants.find(function(item) {
            return String(item.id) === String(swatch.dataset.variantId);
          });
          if (variant) {
            sizeBar.dataset.activeColor = getOptionValue(variant, colorOptionIndex);
          }
        } else {
          var swatchColor = getSwatchColorValue(swatch, colorOptionIndex);
          if (swatchColor) {
            sizeBar.dataset.activeColor = swatchColor;
          }
        }

        updateSizeButtons(product);
      });

      collectionSection.addEventListener('mouseenter', function(evt) {
        var mask = evt.target.closest('.grid-product__image-mask');
        if (!mask) {
          return;
        }

        var product = mask.closest('.grid-product');
        if (product) {
          ensureProductCollectionReady(product);
        }

        var sizeBar = mask.querySelector('[data-collection-size-bar]');
        if (sizeBar) {
          sizeBar.classList.add('is-interactive');
        }
      }, true);

      collectionSection.addEventListener('mouseleave', function(evt) {
        var mask = evt.target.closest('.grid-product__image-mask');
        if (!mask) {
          return;
        }

        var sizeBar = mask.querySelector('[data-collection-size-bar]');
        if (sizeBar) {
          sizeBar.classList.remove('is-interactive');
        }
      }, true);

      collectionSection.addEventListener('mousedown', function(evt) {
        var button = evt.target.closest('.collection-size-bar__btn');
        if (!button) {
          return;
        }
        evt.preventDefault();
        evt.stopPropagation();
      });

      collectionSection.addEventListener('click', function(evt) {
        var button = evt.target.closest('.collection-size-bar__btn');
        if (!button) {
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        if (theme.config.bpSmall || window.innerWidth <= 768) {
          return;
        }

        var product = button.closest('.grid-product');
        if (!product) {
          return;
        }

        ensureProductCollectionReady(product);

        var sizeBar = product.querySelector('[data-collection-size-bar]');
        var form = product.querySelector('[data-collection-size-form]');
        var variants = getProductVariants(product);
        if (!sizeBar || !form || !variants) {
          return;
        }

        var sizeOptionIndex = parseInt(sizeBar.dataset.sizeOptionIndex, 10);
        var colorOptionIndex = sizeBar.dataset.colorOptionIndex;
        colorOptionIndex = colorOptionIndex === undefined || colorOptionIndex === '' ? null : parseInt(colorOptionIndex, 10);
        var sizeValue = button.dataset.sizeValue;
        var activeColor = getActiveColorValue(product, sizeBar, variants, colorOptionIndex);
        var matchedVariant = findVariant(variants, colorOptionIndex, sizeOptionIndex, activeColor, sizeValue);

        if (!matchedVariant || !matchedVariant.available) {
          updateSizeButtons(product);
          return;
        }

        addVariantToCart(product, sizeBar, form, button, matchedVariant);
      });
    }

    // PERF-BS-002: 首屏只绑委托；单卡在首次 hover/点色块/点箭头时 ensureProductCollectionReady
    bindCollectionColorSwatchLock();
    bindCollectionColorGalleryNav();
  };

  theme.initQuickShop = function() {
    var ids = [];
  
    var products = document.querySelectorAll('.grid-product');
    if (!products.length || !theme.settings.quickView) {
      return;
    }
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        el.removeEventListener('focusin', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
    function mobileLoadProductModal(evt) {
      var el = evt.currentTarget;
      el.removeEventListener('click', productMouseover);

      // [2026-09] 修复：PDP「Buy it with」等卡片点 Size 下拉会冒泡到 .grid-product，
      // 误触发 Quick Shop（期望只出原生 option 列表）。交互控件点击直接 return。
      // 不影响：点主图 / 购物袋按钮仍走下方 preload + btn.click() 打开 Quick Shop。
      // 来源：e5de3474 翼果迁移引入整卡 click；此处仅加白名单排除，不改绑定范围。
      if (
        evt.target &&
        evt.target.closest &&
        evt.target.closest(
          [
            'select',
            'option',
            '.gproduct-item-sizes',
            '[data-add-to-cart]',
            '.add-to-cart',
            '.product-block-r',
            '.product-single__form',
            '.cart-upsell-actions',
            '.color-swatch',
            '.grid-product__colors',
            '.collection-size-bar__btn',
            '[data-collection-size-bar]',
            'input',
            'textarea',
            'label'
          ].join(',')
        )
      ) {
        return;
      }
      // [旧逻辑·勿删] 整卡任意点击都打开 Quick Shop（含 select 冒泡），导致 Buy it with 点尺码出弹窗：
      // var el = evt.currentTarget;
      // ... btn.click();

      if (!el || !el.dataset.productId) {
        // Onboarding product, no real data
        return;
      }
      var productId = el.dataset.productId;
      var handle = el.dataset.productHandle;
      var btn = el.querySelector('.quick-product__btn');
      if (!btn) {
        return;
      }
      theme.preloadProductModal(handle, productId, btn).then(() => {
        btn.click();
      });
    }
    products.forEach(product => {
      if (!product.hasAttribute('data-listener-bound')) {
        product.addEventListener('mouseover', productMouseover);
        product.addEventListener('focusin', productMouseover);
        if(window.innerWidth <= 768) {
          product.addEventListener('click', mobileLoadProductModal);
        }
        // 不建议全部 preloadProductModal，会导致巨大的性能开销，建议改成上述按需加载。
        // if (product.querySelector('.quick-product__btn')) {
        //   if (!product || !product.dataset.productId) {
        //     // Onboarding product, no real data
        //     return;
        //   }
        //   var productId = product.dataset.productId;
        //   var handle = product.dataset.productHandle;
        //   var btn = product.querySelector('.quick-product__btn');
        //   theme.preloadProductModal(handle, productId, btn);
        // }
        product.setAttribute('data-listener-bound', 'true');
      }
    });
  
  };
  
  theme.ModelRegister = function() {
    const webModel = document.querySelectorAll('.custom-model-pop-web-wrapper');
    const mobileModel = document.querySelectorAll('.custom-model-pop-mobile-wrapper');
    const mobileModal = document.querySelectorAll('.model-mobile-modal');
    let scrollTop = 0;

    // 打开弹窗
    function openMobileModal(index){
      scrollTop = window.scrollY || document.documentElement.scrollTop;
      document.body.classList.add('modal-open');
      document.body.style.top = `-${scrollTop}px`;
      mobileModal[index].classList.add('active');
    }

    // 关闭弹窗
    function closeMobileModal(){
      document.body.classList.remove('modal-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollTop);
      mobileModal.forEach(item => {
        item.classList.remove('active');
      });
    }
    webModel.forEach(item => {
      function openWebModel(e) {
        e.stopPropagation(); // 阻止冒泡到 document
        item.classList.add('active');
      }
      item.removeEventListener('click', openWebModel);
      item.addEventListener('click', openWebModel);
      // 点击内容区域：不关闭
      function webModelStop(e) {
        e.stopPropagation();
      }
      item.querySelector('.model-modal-web').removeEventListener('click', webModelStop);
      item.querySelector('.model-modal-web').addEventListener('click', webModelStop);
    });
    mobileModel.forEach((item, index) => {
      function openMobileModel(e) {
        e.stopPropagation();
        openMobileModal(index);
      }
      item.removeEventListener('click', openMobileModel);
      item.addEventListener('click', openMobileModel);
    });

    mobileModal.forEach(item => {
      function closeMobileModel(e) {
        e.stopPropagation();
        closeMobileModal();
      }
      item.removeEventListener('click', closeMobileModel);
      item.addEventListener('click', closeMobileModel);
      function mobileModelStop(e) {
        e.stopPropagation();
      }
      item.querySelector('.modle-mobile-content').removeEventListener('click', mobileModelStop);
      item.querySelector('.modle-mobile-content').addEventListener('click', mobileModelStop);
      item.querySelector('.modle-mobile-content').removeEventListener('click', closeMobileModal);
      item.querySelector('.model-info-close').addEventListener('click', closeMobileModal);
    });

    function removeActive (e) {
      webModel.forEach(item => {
        if (item !== e.target) {
          item.classList.remove('active');
        }
      });
      mobileModal.forEach(item => {
        if (item !== e.target) {
          item.classList.remove('active');
        }
      });
    }
    document.removeEventListener('clice', removeActive);
    // 点击页面其他区域
    document.addEventListener('click', removeActive);
  };
  
  theme.preloadProductModal = function(handle, productId, btn) {
    const isDrawer = btn.className.includes('js-drawer');
    var holder = document.getElementById(`QuickShopHolder-${isDrawer ? 'drawer-' : ''}${handle}`);
    var url = theme.routes.home + '/products/' + handle + '?view=' + (isDrawer ? 'drawer' : 'modal');
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
  
    return fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const div = html.querySelector('.product-section[data-product-handle="'+handle+'"]');

      if (!holder) {
        return;
      }
  
      holder.innerHTML = '';
      holder.append(div);
  
      if (isDrawer) {
        // Setup quick view drawer
        var drawerId = 'QuickShopDrawer-' + productId;
        var name = 'quick-drawer-' + productId;
        new theme.Drawers(drawerId, name);
    
        // Register product template inside quick view
        theme.sections.register('product', theme.Product, holder);
    
        // Register collapsible elements
        theme.collapsibles.init();
    
        // Register potential video modal links (when video has sound)
        theme.videoModal();
        const drawerDom = document.getElementById(drawerId);
        if (drawerDom && !drawerDom.querySelector(`#QuickShopHolder-drawer-${handle}`).children.length) {
          drawerDom.querySelector(`#QuickShopHolder-drawer-${handle}`).append(div);
          const webModel = document.querySelectorAll('.custom-model-pop-web-wrapper');
          if (webModel.length) {
            theme.ModelRegister();
          }
        }
        if (drawerDom) {
          document.body.appendChild(drawerDom);
          const obj = {};
          Array.from(document.body.children).forEach((item) => {
            if (item.classList.contains('drawer--quick-shop')) {
              if (!item.querySelector('.product-section') || obj[item.id]) {
                item.remove();
              } else {
                obj[item.id] = true;
              }
            }
          });
        }
        // if (!Array.from(document.body.children).find((i) => i.id == drawerId) && drawerDom && drawerDom.querySelector('.product-section')){
        // } else if (drawerDom && drawerDom.parentElement !== document.body) {
        //   drawerDom.remove();
        // }
      } else {
        // Setup quick view modal
        var modalId = 'QuickShopModal-' + productId;
        var name = 'quick-modal-' + productId;
        new theme.Modals(modalId, name);
    
        // Register product template inside quick view
        theme.sections.register('product', theme.Product, holder);
    
        // Register collapsible elements
        theme.collapsibles.init();
    
        // Register potential video modal links (when video has sound)
        theme.videoModal();
      }
  
      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }
  
  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active',
      // 首页 Hero 翻页方向（PC + 移动端共用）
      slideDirNext: 'slide-dir-next',
      slideDirPrev: 'slide-dir-prev'
    };
  
    var selectors = {
      allSlides: '.slideshow__slide, .announcement-slider__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      const arrowBtn = el.querySelector('.tap-area')
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      // Keep inactive slides out of the a11y tree (aria-hidden + inert) and
      // strip focusability for browsers without inert support.
      updateSlideAriaHidden: function() {
        var slides = this.el.querySelectorAll(selectors.allSlides);
        if (!slides.length) { return }

        var selectedSlide = (this.slideshow && this.slideshow.selectedElement)
          ? this.slideshow.selectedElement
          : null;

        slides.forEach(function(slide) {
          var isSelected = selectedSlide
            ? (slide === selectedSlide)
            : slide.classList.contains('is-selected');

          slide.setAttribute('aria-hidden', isSelected ? 'false' : 'true');

          if (isSelected) {
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('inert', '');
          }

          var focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
          focusableElements.forEach(function(el) {
            if (isSelected) {
              if (el.dataset.slideshowHrefBackup !== undefined) {
                el.setAttribute('href', el.dataset.slideshowHrefBackup);
                delete el.dataset.slideshowHrefBackup;
              }
              if (el.dataset.slideshowTabindexBackup !== undefined) {
                if (el.dataset.slideshowTabindexBackup === '') {
                  el.removeAttribute('tabindex');
                } else {
                  el.setAttribute('tabindex', el.dataset.slideshowTabindexBackup);
                }
                delete el.dataset.slideshowTabindexBackup;
              }
            } else {
              if (el.tagName === 'A' && el.hasAttribute('href') && el.dataset.slideshowHrefBackup === undefined) {
                el.dataset.slideshowHrefBackup = el.getAttribute('href');
                el.removeAttribute('href');
              }
              if (el.dataset.slideshowTabindexBackup === undefined) {
                el.dataset.slideshowTabindexBackup = el.getAttribute('tabindex') || '';
                el.setAttribute('tabindex', '-1');
              }
            }
          });
        });
      },

      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
        this.updateSlideAriaHidden();

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) { AOS.refresh() }
      },

      /**
       * 根据旧/新 index 判断翻页方向
       * next = 左滑/前进（新页从右进、旧页向左出）
       * prev = 右滑/后退（新页从左进、旧页向右出）
       *
       * 旧逻辑（已废弃）：wrapAround 时取最短环绕路径。
       * 相邻滑一次没问题，但点指示点「跳一个」时（如 0→2）会被算成反方向。
       * 新逻辑：仅首尾相邻环绕用特殊判断；其余（含点击 dots）按 index 大小。
       */
      getSlideDirection: function(fromIndex, toIndex, length) {
        if (fromIndex === toIndex || length < 2) {
          return 'next';
        }

        // 仅处理「滑一下」触发的首尾环绕，避免影响指示点跨页点击
        if (this.args.wrapAround) {
          if (fromIndex === length - 1 && toIndex === 0) {
            return 'next';
          }
          if (fromIndex === 0 && toIndex === length - 1) {
            return 'prev';
          }
        }

        // 点右侧指示点 / 前进 → next；点左侧 / 后退 → prev
        return toIndex > fromIndex ? 'next' : 'prev';
      },

      setSlideDirectionClass: function(direction) {
        this.el.classList.remove(classes.slideDirNext, classes.slideDirPrev);
        this.el.classList.add(direction === 'prev' ? classes.slideDirPrev : classes.slideDirNext);
      },

      slideChange: function(index) {
        this.updateSlideAriaHidden();

        // 按滑动/切换方向设置 class，驱动 CSS 入场/出场方向（PC + MO 同一套）
        if (this.args.fade) {
          var slides = this.el.querySelectorAll(selectors.allSlides);
          var fromIndex = this.currentSlide
            ? Array.prototype.indexOf.call(slides, this.currentSlide)
            : 0;
          var direction = this.getSlideDirection(fromIndex, index, slides.length);
          this.setSlideDirectionClass(direction);
        }

        // Outgoing fade styles
        // 旧逻辑（已废弃）：transitionend 里用 this.currentSlide 清理，settle 后 currentSlide
        // 已指向新页，会误删新页 class 并造成闪动。改为捕获离场 slide，并由 afterChange 兜底清理。
        // if (this.args.fade && this.currentSlide) {
        //   this.currentSlide.classList.add(classes.animateOut);
        //   this.currentSlide.addEventListener('transitionend', function() {
        //     this.currentSlide.classList.remove(classes.animateOut);
        //   }.bind(this));
        // }
        if (this.args.fade && this.currentSlide) {
          var outgoingSlide = this.currentSlide;
          outgoingSlide.classList.add(classes.animateOut);
          var onAnimationEnd = function(evt) {
            // 出场动画挂在 .hero__image-wrapper 上
            if (!evt.target || !evt.target.classList.contains('hero__image-wrapper')) {
              return;
            }
            outgoingSlide.classList.remove(classes.animateOut);
            outgoingSlide.removeEventListener('animationend', onAnimationEnd);
          };
          outgoingSlide.addEventListener('animationend', onAnimationEnd);
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);
        this.updateSlideAriaHidden();
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
  
        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled'
    };
  
    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
  
      this.init();
    }
  
    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));
  
        // Set default state based on current selected variant
        this.setInitialAvailability();
      },
  
      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {
  
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
  
            if (variant[index] === null) return;
  
            let entry = options[index].find(option => option.value === variant[index]);
  
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true}
              options[index].push(entry);
            }
  
            const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')
  
            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })
  
          return options;
        }, { option1: [], option2: [], option3: []})
      },
  
      setInitialAvailability: function() {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        const currentlySelectedValues = this.currentVariantObject.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },
  
      setAvailability: function(evt) {
        const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant} = evt.detail;
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)
        const menutabele = document.querySelector('#pc-menu-tab-color')
        if(menutabele){
          const swatchData = this.generateSwatchData(lastSelectedValue);
          menutabele.style.backgroundColor = swatchData.colorSwatchFallback;
          menutabele.style.backgroundImage = `url(${swatchData.colorImage})`;
        }
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },
      generateSwatchData: function (currentValue) {
        const swatchFileExtension = 'png';
        // 将字符串转换为合法的 handle 格式
        function toHandle(value) {
          return value.trim().toLowerCase().replace(/\s+/g, '-');
        }
        const colorFileName = `${toHandle(currentValue)}_50x50.${swatchFileExtension}`;
        // 假设 Shopify 的文件基础 URL（需要替换为你的实际 URL 前缀）
        const shopifyBaseUrl = 'https://ruc8jdjpu6un077r-60723986608.shopifypreview.com/cdn/shop/files/';
        const colorImage = `${shopifyBaseUrl}${colorFileName}`;
        // 备用颜色值
        const colorSwatchFallback = toHandle(currentValue.split(' ').pop());
        return { colorImage, colorSwatchFallback, };
      },
  
      manageOptionState: function(option, values) {
        // Support multiple fieldsets with same data-index (e.g., grouped color variants)
        var groups = this.container.querySelectorAll('.variant-input-wrap[data-index="'+ option +'"]');

        // Loop through each option value
        values.forEach(obj => {
          // Try to find the variant in all matching fieldsets
          Array.from(groups).forEach(group => {
            this.enableVariantOption(group, obj);
          });
        });
      },

      enableVariantOption: function(group, obj) {
        if (!group) {
          return;
        }
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
        if (this.type === 'dropdown') {
          var optionElement = group.querySelector('option[value="'+ value +'"]');
          if (optionElement) {
            if (obj.soldOut) {
              optionElement.disabled = true;
            } else {
              optionElement.disabled = false;
            }
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          if (!buttonGroup) {
            return;
          }
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');
          if (!input || !label) {
            return;
          }

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
    var vimeoPlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  
  /*============================================================================
    Size chart IN/CM unit toggle
  ==============================================================================*/

  theme.sizeChartUnitToggle = (function() {
    var IN_UNIT_RE = /(\(|（)\s*IN\s*(\)|）)/i;
    var CM_UNIT_RE = /(\(|（)\s*CM\s*(\)|）)/i;
    var DASH_RE = /[\u2013\u2014\u2212–—]/g;
    var initialized = false;

    function headerHasInUnit(text) {
      return IN_UNIT_RE.test(text);
    }

    function headerHasCmUnit(text) {
      return CM_UNIT_RE.test(text);
    }

    function setHeaderUnit(text, unit) {
      if (unit === 'cm') {
        return text.replace(/(\(|（)\s*IN\s*(\)|）)/gi, '(CM)');
      }
      return text.replace(/(\(|（)\s*CM\s*(\)|）)/gi, '(IN)');
    }

    function formatCmNumber(num) {
      var cm = num * 2.54;
      return String(Math.round(cm * 10) / 10);
    }

    function convertSingleInchToCm(val) {
      var num = parseFloat(String(val).trim());
      if (isNaN(num)) return null;
      return formatCmNumber(num);
    }

    function convertInchValueToCm(value) {
      var normalized = String(value).trim().replace(DASH_RE, '-');
      if (!normalized) return value;

      if (normalized.indexOf('-') !== -1) {
        var parts = normalized.split('-');
        var start = convertSingleInchToCm(parts[0]);
        var end = convertSingleInchToCm(parts[parts.length - 1]);
        if (start !== null && end !== null) {
          return start + '-' + end;
        }
      }

      var single = convertSingleInchToCm(normalized);
      return single !== null ? single : value;
    }

    function getHeaderRows($table) {
      return $table.find('thead tr');
    }

    function getMeasureHeaderRow($table) {
      var $rows = getHeaderRows($table);
      return $rows.length ? $rows.last() : $();
    }

    function setUnitButtons($toolTip, unit) {
      if (!$toolTip.length) return;
      if (unit === 'cm') {
        $toolTip.find('.cm-btn').addClass('active');
        $toolTip.find('.inch-btn').removeClass('active');
      } else {
        $toolTip.find('.inch-btn').addClass('active');
        $toolTip.find('.cm-btn').removeClass('active');
      }
    }

    function processTable($table, toCm) {
      var $headerRow = getMeasureHeaderRow($table);
      if (!$headerRow.length) return;

      $headerRow.children('th').each(function(headerIndex) {
        var $header = $(this);
        var headerText = $header.text();
        var isMeasureColumn = toCm ? headerHasInUnit(headerText) : headerHasCmUnit(headerText);
        if (!isMeasureColumn) return;

        $header.text(setHeaderUnit(headerText, toCm ? 'cm' : 'in'));

        var tdIndex = headerIndex - 1;
        if (tdIndex < 0) return;

        $table.find('tbody tr').each(function() {
          var $cell = $(this).children('td').eq(tdIndex);
          if (!$cell.length) return;

          if (toCm) {
            var value = $cell.text().trim();
            if (!$cell.attr('data-old-in')) {
              $cell.attr('data-old-in', value);
            }
            $cell.text(convertInchValueToCm(value));
          } else {
            var oldValue = $cell.attr('data-old-in');
            if (oldValue !== undefined) {
              $cell.text(oldValue);
            }
          }
        });
      });
    }

    function processCharts($root, toCm) {
      $root.find('.popup-chart-size__content table').each(function() {
        processTable($(this), toCm);
      });
    }

    function init() {
      if (initialized) return;
      initialized = true;

      $(document).on('click', '.cm-btn', function(event) {
        event.preventDefault();
        var $toolTip = $(this).closest('tool-tip');
        setUnitButtons($toolTip, 'cm');
        processCharts($toolTip.length ? $toolTip : $(document), true);
      });

      $(document).on('click', '.inch-btn', function(event) {
        event.preventDefault();
        var $toolTip = $(this).closest('tool-tip');
        setUnitButtons($toolTip, 'in');
        processCharts($toolTip.length ? $toolTip : $(document), false);
      });
    }

    return { init: init };
  })();

  theme.sizeChartUnitToggle.init();

  /*============================================================================
    Size chart modal（tabs / model info）— 单次委托绑定，避免每次打开重复绑事件
  ==============================================================================*/

  theme.sizeChartModal = (function() {
    var initialized = false;
    var sizeChartCurrTab = 0;
    var sizeChartCurrTab2 = 0;

    function setTab1($toolTip, index) {
      var $tabs = $toolTip.find('.size-chart__tabs .size-chart__tabs_item');
      var $contents = $toolTip.find('.size-chart__inner');
      if (!$tabs.length) return;

      $tabs.each(function(i) {
        $(this).toggleClass('active', i === index);
      });
      $contents.each(function(i) {
        $(this).toggleClass('show', i === index);
      });

      var tabWidth = $tabs.eq(index).outerWidth();
      $toolTip.find('.size-chart__tabs .size-chart__tabs_style').first().css({ width: tabWidth + 'px' });
    }

    function setTab2($toolTip, index) {
      var $tabs = $toolTip.find('.size-chart__tabs2 .size-chart__tabs_item');
      var $contents = $toolTip.find('.popup-chart-size__content2 .size-chart__inner');
      if (!$tabs.length) return;

      $tabs.each(function(i) {
        $(this).toggleClass('active', i === index);
      });
      $contents.each(function(i) {
        $(this).toggleClass('show', i === index);
      });

      var $tab = $tabs.eq(index);
      var tabWidth = $tab.outerWidth();
      var tabPosition = $tab.position().left;
      $toolTip.find('.size-chart__tabs2 .size-chart__tabs_style').first().css({
        width: tabWidth + 'px',
        left: tabPosition
      });
    }

    function onOpen($toolTip) {
      sizeChartCurrTab = 0;
      sizeChartCurrTab2 = 0;

      requestAnimationFrame(function() {
        setTab1($toolTip, sizeChartCurrTab);
        if ($toolTip.find('.size-chart__tabs2').length) {
          setTab2($toolTip, sizeChartCurrTab2);
        }
      });
    }

    function init() {
      if (initialized) return;
      initialized = true;

      $(document).on('click', '.size-chart__tabs .size-chart__tabs_item', function() {
        var $toolTip = $(this).closest('tool-tip');
        if (!$toolTip.length) return;
        sizeChartCurrTab = $(this).index();
        setTab1($toolTip, sizeChartCurrTab);
      });

      $(document).on('click', '.size-chart__tabs2 .size-chart__tabs_item', function() {
        var $toolTip = $(this).closest('tool-tip');
        if (!$toolTip.length) return;
        sizeChartCurrTab2 = $toolTip.find('.size-chart__tabs2 .size-chart__tabs_item').index(this);
        setTab2($toolTip, sizeChartCurrTab2);
      });

      $(document).on('click', '.modelSection .model-btn', function() {
        var $btn = $(this);
        var $section = $btn.parents('.modelSection');
        $section.find('.choose-label-model .model-btn').removeClass('active');
        $btn.addClass('active');
        var index = $btn.parent().find('.model-btn').index(this);
        $section.find('.tableMain .model-table').hide();
        $section.find('.model-table').eq(index).show();
      });
    }

    return { init: init, onOpen: onOpen };
  })();

  theme.sizeChartModal.init();

  /*============================================================================
    ToolTip
  ==============================================================================*/
  
  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');
  
      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');
  
      this.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
        if(e.target.id == 'sizeHx-modal') {
          var toolTip = document.querySelector('.noModal tool-tip');
          if (toolTip) {
              toolTip.setAttribute('data-tool-tip-open', 'false');
          }
        }
        // 尺码表 tabs / 模特切换：改由 theme.sizeChartModal 单次委托（见文件顶部模块）
        theme.sizeChartModal.onOpen($(this));

        /* [性能优化] 以下逻辑已注释：每次 tooltip:open 重复 .bind() / .on()，打开次数越多越卡；
           且使用全局选择器 $(".size-chart__tabs_item") 扫描整页 DOM，并含 300ms 人为延迟。
        sizeChartCurrTab = 0;
        const setTab = (index, delay = 0) => {
          const tabs = $(
            ".size-chart__tabs .size-chart__tabs_item"
          );
          const contents = $(".size-chart__inner");
          for (let i = 0; i < tabs.length; i++) {
            tabs[i].classList.remove("active");
            contents[i].classList.remove("show");
          }
          const tab = $(
            ".size-chart__tabs .size-chart__tabs_item:eq(" +
            index +
            ")"
          );
          tab.addClass("active");
          $(".size-chart__inner:eq(" + index + ")").addClass(
            "show"
          );
          setTimeout(() => {
            const tabWidth = tab.width();
            $(
              ".size-chart__tabs .size-chart__tabs_style:eq(0)"
            ).css({ width: tabWidth + "px" });
          }, delay);
        };
        setTimeout(() => {
          setTab(sizeChartCurrTab, 300);
        }, 0);
        $(".size-chart__tabs .size-chart__tabs_item").bind(
          "click",
          function (e) {
            const index = $(".size-chart__tabs_item").index(this);
            sizeChartCurrTab = index;
            setTab(index);
          }
        );
        if($('.size-chart__tabs2').length > 0) {
          var sizeChartCurrTab = 0;
          const setTab = (index, delay = 0) => {
            const tabs = $(
              ".size-chart__tabs2 .size-chart__tabs_item"
            );
            const contents = $(".popup-chart-size__content2 .size-chart__inner");
            for (let i = 0; i < tabs.length; i++) {
              tabs[i].classList.remove("active");
              contents[i].classList.remove("show");
            }
            const tab = $(
              ".size-chart__tabs2 .size-chart__tabs_item:eq(" +
              index +
              ")"
            );
            tab.addClass("active");
            $(".popup-chart-size__content2 .size-chart__inner:eq(" + index + ")").addClass(
              "show"
            );
            setTimeout(() => {
              const tabPosition = tab.position().left;
              const tabWidth = tab.width();
              $(".size-chart__tabs2 .size-chart__tabs_style:eq(0)").css({ width: tabWidth + "px", left: tabPosition });
            }, delay);
          };
          setTimeout(() => {
            setTab(sizeChartCurrTab, 0);
          }, 0);
          $('.size-chart__tabs2 .size-chart__tabs_item').on('click', function() {
              const index = $(".size-chart__tabs2 .size-chart__tabs_item").index(this);
              sizeChartCurrTab = index;
              setTab(index);
          });
        }
        $(".model-btn").click(function() {
            $(this).parents('.choose-label-model').find('.model-btn').removeClass("active");
            $(this).addClass("active");
            var buttonGroup = $(this).parent().find(".model-btn");
            var index = buttonGroup.index(this);
            $(this).parents('.modelSection').find('.tableMain .model-table').hide();
            $(this).parents('.modelSection').find(".model-table").eq(index).show();
        });
        */
      });
    }
  
    _portalToBody() {
      // 脱离 product-single__sticky 等祖先的层叠上下文，避免 fixed 弹窗被 Header 盖住
      // 同 product-form.liquid 中 gmenu-tab 挂 body 的处理思路
      if (this.parentNode === document.body) return;
      if (!this._portalAnchor) {
        this._portalAnchor = document.createComment('tool-tip-anchor');
      }
      var parent = this.parentNode;
      if (parent) {
        parent.insertBefore(this._portalAnchor, this);
        document.body.appendChild(this);
      }
    }

    _restorePortal() {
      if (!this._portalAnchor || !this._portalAnchor.parentNode) return;
      this._portalAnchor.parentNode.insertBefore(this, this._portalAnchor);
      this._portalAnchor.remove();
      this._portalAnchor = null;
    }

    _open(context, insertedHtml) {
      // this.toolTipContent.innerHTML = insertedHtml;

      this._portalToBody();
  
      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }
  
      this._lockScrolling();
  
      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }
  
      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });
  
      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });
  
      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;



    }
  
    _close() {
      // this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';
  
      this._unlockScrolling();

      this._restorePortal();
  
      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }
  
    _lockScrolling() {
      // 仅对弹窗内容区 trapFocus，避免扫描整个 tool-tip 内大量隐藏 DOM
      var focusContainer = this.inner || this.el;
      theme.a11y.trapFocus({
        container: focusContainer,
        namespace: 'tooltip_focus'
      });

      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }

    _unlockScrolling() {
      var focusContainer = this.inner || this.el;
      theme.a11y.removeTrapFocus({
        container: focusContainer,
        namespace: 'tooltip_focus'
      });
  
      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }
  
  customElements.define('tool-tip', ToolTip);
  
  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/
  
  const throttle = (fn, wait) => {
    let prev, next;
    return function invokeFn(...args) {
      const now = Date.now();
      next = clearTimeout(next);
      if (!prev || now - prev >= wait) {
        // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        prev = now;
      } else {
        next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
      }
    };
  };

  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }
  
    // init() {
    //   const toolTipOpen = new CustomEvent('tooltip:open', {
    //     detail: {
    //       context: this.dataset.toolTip,
    //       content: this.toolTipContent.innerHTML
    //     },
    //     bubbles: true
    //   });
  
    //   this.el.addEventListener('click', e => {
    //     e.stopPropagation();
    //     this.dispatchEvent(toolTipOpen);
    //   });
    // }
    init() { // 兼容捆绑子产品-gzg
      this.addEventListener('click', e => {
        e.stopPropagation();
        const targetToolTip = this.closest('.bundle-product-item')?.querySelector('tool-tip') || document.querySelector('tool-tip');
        if (!targetToolTip) {
          return;
        }
        const toolTipOpen = new CustomEvent('tooltip:open', {
          detail: {
            context: this,
            content: this.toolTipContent?.innerHTML || ''
          },
          bubbles: false
        });

        targetToolTip.dispatchEvent(toolTipOpen);
      });
    }
  }
  
  customElements.define('tool-tip-trigger', ToolTipTrigger);
  
  /*============================================================================
    NewsletterReminder
  ==============================================================================*/
  
  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');
  
      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${ this.id }`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
  
      this.init();
    }
  
    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });
  
      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });
  
      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));
  
      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });
  
      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);
  
        this.hide();
      });
    }
  
    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          try {
            sessionStorage.setItem('reminderAppeared', true);
          } catch (error) {
            if (error.name === 'QuotaExceededError') {
              console.warn('无法保存提醒状态：存储空间不足');
            }
          }
        }, time * 1000);
      }
    }
  
    hide() {
      this.dataset.enabled = 'false';
    }
  }
  
  customElements.define('newsletter-reminder', NewsletterReminder);
  
  /*============================================================================
    ImageElement
  ==============================================================================*/
  
  class ImageElement extends HTMLElement {
    constructor() {
      super();
  
      this.init();
    }
  
    init() {
  
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
  
        this.removeAnimations();
  
        observer.unobserve(this);
      }
  
      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  
    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');
  
      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }
  
      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }
  
  customElements.define('image-element', ImageElement);
  
  /*============================================================================
    PredictiveSearch
  ==============================================================================*/
  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.predictiveSearchRecommend = this.querySelector('#predictive-search-recommend');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;
      this.popularSearchesLink = this.querySelectorAll('[data-popular-searches-link]');
      this.form =  this.querySelector('form[role="search"]');
  
      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');
  
        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus(); }, 100);
  
        document.body.classList.add('predictive-overflow-hidden');
        this.predictiveSearchRecommend.style.display = 'block';
        this.onChange()
      });
  
      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 100);
              }
            }
          });
        });
  
        observer.observe(this.SearchModal, {
          attributes: true
        });
      }
  
      if (this.enabled === 'false') return;
  
      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.popularSearchesLink.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          const popularSearchText = event.target.textContent.trim();

          this.input.value = popularSearchText;
          this.onChange();
          this.form.submit();
        });
      });
      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      this.screen.addEventListener('click', () => { this.close(); });
    }
  
    onChange(isKeyDown) {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) return;
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      const searchObj = {
        'q': searchTerm,
        'resources[limit]': 3,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };
  
      const params = this.paramUrl(searchObj);
  
      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
  
          AOS.refreshHard();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.predictiveSearchRecommend.style.display = 'none';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchRecommend.style.display = 'block';
      // this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
  
      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
      this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
      this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
      this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
      this.dateInput = this.querySelector(`#Recipient-send-on-${ this.dataset.sectionId }`);
      this.addEventListener('change', () => this.onChange());
      this.recipientFields = this.querySelector('.recipient-fields');
  
      this.checkboxInput.addEventListener('change', () => {
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
      });
    }
  
    connectedCallback() {
      document.addEventListener('ajaxProduct:error', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.displayErrorMessage(event.detail.errorMessage);
        }
      });
  
      document.addEventListener('ajaxProduct:added', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      });
    }
  
    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  
    clearInputFields() {
      this.querySelectorAll('.field__input').forEach(el => el.value = '');
    }
  
    displayErrorMessage(body) {
      this.clearErrorMessage();
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;
  
          inputElement.setAttribute('aria-invalid', true);
          inputElement.classList.add('field__input--error');
        });
      }
    }
  
    clearErrorMessage() {
      this.querySelectorAll('.field__input').forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
        inputElement.classList.remove('field__input--error');
      });
    }
  };
  
  customElements.define('recipient-form', RecipientForm);
  

  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left',
      prevNextButtons: true
    };
    var bar;
    var flickity;
  
    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
  
      if (bar.dataset.blockCount === 1) {
        return;
      }
  
      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }
  
    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }
  
    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }
  
    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();
  
        document.addEventListener('ajaxProduct:added', function(evt) {
          
          if (evt.target.closest('.drawer.drawer--is-open.drawer--quick-shop')) {
            evt.target.closest('.drawer.drawer--is-open.drawer--quick-shop').classList.remove('drawer--is-open');
          }
          this.cartForm.buildCart();
          this.open();
        }.bind(this));
  
        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },
  
      open: function() {
        this.drawer.open();
  
        theme.a11y.trapFocus({
          container: this.form,
          elementToFocus: this.form,
          namespace: 'cartdrawer_focus'
        });
      },
  
      close: function() {
        this.drawer.close();
  
        theme.a11y.removeTrapFocus({
          container: this.form,
          namespace: 'cartdrawer_focus'
        });
      }
    });
  
    return CartDrawer;
  })();
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      navDetails: '.site-nav__details',
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0,
      stickyOpenTimer: null
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        // 以 data-overlay 为准，避免仅靠初始 class 导致滚回顶部无法恢复透明
        config.wrapperOverlayed = theme.settings.overlayHeader || wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }
  
      menuDetailsHandler();
      searchDrawer();
    }
  
    function bindNavSummaryLinks(navDetail) {
      /* [A11Y-B 已停用] 原 summary 内 a 的点击穿透处理 —— 新结构无 summary
      navDetail.querySelectorAll('summary a.site-nav__link[href]').forEach((link) => {
        const url = link.getAttribute('href');
        if (!url || url === '#' || url === '/#' || /#$/.test(url)) {
          return;
        }
        link.addEventListener('mousedown', (evt) => {
          evt.stopPropagation();
        });
        link.addEventListener('click', (evt) => {
          evt.stopPropagation();
        });
      });
      */
    }

    function menuDetailsHandler() {
      /* [A11Y-B 已停用] 原 details/summary open 切换 —— 撤回时恢复本段并删除下方 A11Y-B 新逻辑
      const navDetails = document.querySelectorAll(selectors.navDetails);
      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');
        if (!summary) {
          return;
        }
        bindNavSummaryLinks(navDetail);
        document.addEventListener('click', (evt) => {
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
      */

      // A11Y-B：一级可点跳转；下拉靠 CSS hover/focus-within；is-focused 给透明顶栏等状态用
      // 关闭时与 CSS 同步瞬时收起（custom.css 关闭无 transition），避免一级底色与二级面板不同步
      document.querySelectorAll('.site-nav--has-dropdown').forEach((item) => {
        const trigger = item.querySelector(':scope > .site-nav__link');
        if (!trigger) {
          return;
        }

        const setOpen = (open) => {
          item.classList.toggle('is-focused', open);
          if (trigger.hasAttribute('aria-expanded')) {
            trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          }
          // 下拉从 visibility:hidden 打开时，补一次 lazy 图加载（避免推图空白）
          if (open) {
            item.querySelectorAll('.megamenu img[loading="lazy"]').forEach((img) => {
              if (!img.complete) {
                img.loading = 'eager';
              }
            });
          }
        };

        item.addEventListener('mouseenter', () => setOpen(true));
        item.addEventListener('mouseleave', () => {
          if (!item.contains(document.activeElement)) {
            setOpen(false);
          }
        });
        item.addEventListener('focusin', () => setOpen(true));
        item.addEventListener('focusout', (evt) => {
          if (!item.contains(evt.relatedTarget)) {
            setOpen(false);
          }
        });
      });
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      // siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
      //   var h = nav.offsetHeight;
      //   if (h > largestMegaNav) {
      //     largestMegaNav = h;
      //   }
      // });
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
      config.prevScrollPos = window.pageYOffset;

      // 避免 section 重载 / 重复 init 时套多层 StickyHeaderWrap
      if (!document.getElementById(config.stickyHeaderWrapper)) {
        var wrapWith = document.createElement('div');
        wrapWith.id = config.stickyHeaderWrapper;
        theme.utils.wrap(siteHeader, wrapWith);
      }

      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();

      window.off('resize' + config.namespace);
      window.off('scroll' + config.namespace);
      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      // 不用 theme.utils.throttle：它只跑 leading、丢掉 trailing，
      // 快速滚回顶部时最后一次 scrollY≈0 会被吞掉，导航会卡在白底 stuck 态
      window.on('scroll' + config.namespace, stickyHeaderScroll);

      // 刷新/滚动位置恢复后立刻同步吸顶态，避免 Header 未 sticky、右侧图标被挤/盖住
      var syncStickyState = function() {
        stickyHeaderScroll();
        stickyHeaderHeight();
      };
      requestAnimationFrame(syncStickyState);
      if (!config.stickySyncBound) {
        config.stickySyncBound = true;
        window.addEventListener('pageshow', syncStickyState);
        window.addEventListener('load', syncStickyState);
      }

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
          syncStickyState();
        }, 250);
      }
    }
  
    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;
  
      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }
  
    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
  
      var h = siteHeader.offsetHeight;
  
      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }
  
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      // 恢复占位高度：fixed 吸顶后避免文档流塌陷，导致布局把右侧 icons 挤出/盖住
      if (stickyHeader) {
        stickyHeader.style.height = h + 'px';
      }
    }
  
    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }
  
      if (config.forceStopSticky) {
        return;
      }

      // rAF 合并同帧多次 scroll；保证松手后仍会用最新 scrollY 同步一次
      if (config.scrollTick) {
        return;
      }
      config.scrollTick = true;
      requestAnimationFrame(function() {
        config.scrollTick = false;
        scrollHandler();
        config.lastScroll = window.scrollY;
      });
    }
  
    function scrollHandler() {
      const announcement = document.querySelector('.announcement-bar');
      const maxScrollHeight = announcement?.clientHeight || 0;
      // 用 pageYOffset 兼容性更好；<= 阈值即回透明，避免卡在临界白底
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const shouldStick = scrollY > maxScrollHeight;

      if (shouldStick) {
        if (!config.stickyActive) {
          config.stickyActive = true;
          siteHeader.classList.add(config.stickyClass);
          if (config.wrapperOverlayed) {
            wrapper.classList.remove(config.overlayedClass);
          }

          clearTimeout(config.stickyOpenTimer);
          // 立刻加 opening，避免 stuck 默认 translateY(-100%) 把导航裁在视口外
          siteHeader.classList.add(config.openTransitionClass);
        } else if (!siteHeader.classList.contains(config.openTransitionClass)) {
          // 刷新后可能只有 stuck、缺少 opening，补齐以免 Header 卡在屏外
          siteHeader.classList.add(config.openTransitionClass);
        }
      } else {
        // 始终按滚动位置同步 DOM，修复「stickyActive 已 false 但白底/无 is-light」卡住
        clearTimeout(config.stickyOpenTimer);
        config.stickyOpenTimer = null;
        config.stickyActive = false;
        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', function(evt) {
          evt.preventDefault();

          evt.stopPropagation();
          document.dispatchEvent(new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header'
            },
            bubbles: true
          }));
  
          // add is-active class to .site-header__search-container
          document.querySelector(selectors.searchContainer).classList.add('is-active');
          const test = window.location.pathname;
          const index = test.lastIndexOf("\/");
          const page_category = test.slice(1,index) || 'Home'
          const page_name = test.substring(index + 1,test.length) || 'Home'
          var first_navi_category = $(this).attr('data-name')
          window.dataLayer.push({
            event: "first_navi_click",
            first_navi_category: first_navi_category,
            page_category: page_category,
            page_name: page_name
          });
        });
      });
  
      document.addEventListener('predictive-search:close-all', function() {
        closeSearchDrawer();
      });
    }
  
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSizes) {
    var output = '';
  
    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSizes);
  
      let priceMarkup = '';
      let vendorMarkup = '';
  
      if (theme.settings.predictiveSearchPrice) priceMarkup = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}</div>`;
      if (theme.settings.predictiveSearchVendor) vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;
  
      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
                ${vendorMarkup}
              </div>
            </a>
          </div>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildProductImage = function(product, imageSizes) {
    var size = theme.settings.productImageSize;
    var output = '';
  
    if (size === 'natural') {
      const template = document.getElementById("naturalImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');
  
      imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    } else {
      const template = document.getElementById("fixedRatioImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');
  
      imageWrapperEl.classList.add(`grid__image-ratio--${size}`);
  
      if (!theme.settings.productImageCover) {
        imageEl.classList.add('grid__image-contain');
      }
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    }
  
    function addImageProperties(imageEl, imageSizes) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = product.image_responsive_urls.toString();
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes;
    }
  
    return output;
  }
  

  /*============================================================================
    Age Verification Popup
  ==============================================================================*/
  
  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();
  
      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);
  
      this.classes = {
        activeContent: 'age-verification-popup__content--active',
        inactiveContent: 'age-verification-popup__content--inactive',
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active',
      }
  
      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');
  
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        })
  
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
  
            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }
  
            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);
  
            if (!secondViewVisited) return;
  
            this.showDeclineContent();
          }
        })
  
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close();
          }
        })
      }
  
      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR visibility is toggled in the editor
      if ((this.cookie) && this.dataset.testMode === 'false') return;
  
      this.init();
    }
  
    init() {
      this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false
      });
  
      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }
  
      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }
  
      this.modal.open();
  
      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
  
      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent();
  
          // If in editor, save to session storage to indicate that user has moved on to the second view
          // Allows view to persist while making changes in the editor
          if (Shopify.designMode) {
            try {
              sessionStorage.setItem(this.id, 'second-view');
            } catch (error) {
              if (error.name === 'QuotaExceededError') {
                console.warn('无法保存视图状态：存储空间不足');
              }
            }
          }
        });
      }
  
      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();
  
          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);
  
          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }
  
      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();
  
          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
          }
  
          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }
  
          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }
  
          this.modal.close();
  
          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }
  
    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);
  
      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }
  
    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);
  
      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }
  
  customElements.define('age-verification-popup', AgeVerificationPopup);
  
  
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            try {
              sessionStorage.setItem('newsletterAppeared', true);
            } catch (error) {
              if (error.name === 'QuotaExceededError') {
                console.warn('无法保存新闻订阅状态：存储空间不足');
              }
            }
          }
  
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }
  
        this.items = this.getImageData();
  
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
  
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
  
        this.initGallery(this.items, index);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },
  
      getImageData: function() {
        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
  
        var items = [];
        var options = {};
  
        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.init();
  
        this.preventiOS15Scrolling();
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },
  
      syncHeight: function() {
        document.documentElement.style.setProperty(
          "--window-inner-height", 
          `${window.innerHeight}px`
        );
      },
  
      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function() {
        let initialScrollPos;
  
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return; 
        
        this.syncHeight();
              
        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;
        
        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');
  
        window.addEventListener('resize', this.syncHeight);
      
        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos);
        });
      }
    });
  
    return Photoswipe;
  })();
  
  
  /*============================================================================
    ProductRecommendations
  ==============================================================================*/
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url;
      this.intent = this.dataset.intent;
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults =  this.querySelector('.grid-product');
      this.sectionId = this.dataset.sectionId;
      this.blockId = this.dataset.blockId;
  
      document.addEventListener('recommendations:loaded', (e) => {
        this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
        if (this.colorImages.length) {
          this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
          this.colorSwatchHovering();
        }
      });
    }
  
    connectedCallback() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
  
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (!recommendations) {
          this.el.classList.add('hide');
          if (AOS) { AOS.refreshHard() }
          return;
        }
  
        this.placeholder.innerHTML = '';
        this.placeholder.innerHTML = recommendations.innerHTML;
  
        theme.reinitProductGridItem(this.el);
  
        this.slideshow = this.querySelector('[data-slideshow]');
  
        if (this.slideshow) {
          this.setupSlider();
        }
  
        document.dispatchEvent(new CustomEvent('recommendations:loaded', {
          detail: {
            section: this.el,
            intent: this.intent
          }
        }));
  
        })
        .catch(e => {
          console.error(e);
        });
    }
  
    setupSlider() {
      const controlType = this.slideshow.dataset.controls;
      const perSlide = parseFloat(this.slideshow.dataset.perSlide);
      const count = parseFloat(this.slideshow.dataset.count);
  
      let prevNextButtons = false;
      let pageDots = true;
  
      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }
  
      if (perSlide < count) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true,
          wrapAround: false,
        });
      }
    }
  
    colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);
  
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }
  
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        this.slideshow.classList.remove('loading', 'loading--delayed');
        this.slideshow.classList.add('loaded');
  
        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else if (slides[0]) {
          slides[0].classList.add('is-selected');
          slides[0].setAttribute('aria-hidden', 'false');
          slides[0].removeAttribute('inert');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });

    document.querySelector('.yiguoseo')?.remove();
  
    return SlideshowSection;
  })();
  
  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };
  
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }
  
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';
  
        var self = this;
  
        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }
  
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
  
            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }
  
            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }
  
            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });
  
    return StoreAvailability;
  })();
  
  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  
  /*============================================================================
    CountdownTimer
  ==============================================================================*/
  
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;
  
      this.timerComplete = false;
  
      this.init();
    }
  
    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
  
    }
  
    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };
  
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;
  
        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }
  
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }
  
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }
  
        this.timerComplete = true;
      }
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);
  
  /*============================================================================
    HotSpots
  ==============================================================================*/
  
  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]');
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
      this.blockContainer = this.querySelector('[data-block-container]');
      this.colorImages = this.querySelectorAll('.grid-product__color-image');
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');
  
      this._bindEvents();
      this._setupQuickShop();
  
      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }
  
    _colorSwatchHovering() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this._setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this._removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.colorSwatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');
  
      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }
  
    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  
    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach(button => {
        const id = button.dataset.button;
  
        button.on('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });
  
      // Display active hotspot block on theme editor select
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }
  
    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }
  
    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof theme.QuickShop === 'function') {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === 'function') {
          theme.initQuickShop();
        }
  
        if (typeof theme.QuickAdd === 'function') {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }
  
  customElements.define('hot-spots', HotSpots);
  
  /*============================================================================
    ImageCompare
  ==============================================================================*/
  
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');
  
      this.calculateSizes();
  
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);
  
      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);
  
      window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true)}));
  
      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }
  
    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.elWidth = this.el.offsetWidth;
  
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
  
      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }
  
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }
  
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }
  
      if (e.target === this.button) {
        this.active = true;
      }
    }
  
    dragEnd(e) {
      this.initialX = this.currentX;
  
      this.active = false;
    }
  
    drag(e) {
      if (this.active) {
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }
  
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;
  
      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;
  
      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }
  
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }
  
  customElements.define('image-compare', ImageCompare);
  
  class ExternalVideo extends HTMLElement {
    constructor() {
        super();
        this.hasLoaded = false;
        (async()=>{
            if (this.autoPlay) {
                await this.untilVisible({
                    rootMargin: "300px",
                    threshold: 0
                });
                this.play()
            } else {
                this.addEventListener("click", this.play.bind(this), {
                    once: true
                })
            }
        }
        )()
    }
    get autoPlay() {
        return this.hasAttribute("autoplay")
    }
    get provider() {
        return this.getAttribute("provider")
    }
    async play() {
        if (!this.hasLoaded) {
            await this._setupPlayer()
        }
        if (this.provider === "youtube") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                event: "command",
                func: "playVideo",
                args: ""
            }), "*")
        } else if (this.provider === "vimeo") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                method: "play"
            }), "*")
        }
    }
    pause() {
        if (!this.hasLoaded) {
            return
        }
        if (this.provider === "youtube") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: ""
            }), "*")
        } else if (this.provider === "vimeo") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                method: "pause"
            }), "*")
        }
    }
    _setupPlayer() {
        if (this._setupPromise) {
            return this._setupPromise
        }
        return this._setupPromise = new Promise(resolve=>{
            const template2 = this.querySelector("template")
              , node = template2.content.firstElementChild.cloneNode(true);
            node.onload = ()=>{
                this.hasLoaded = true;
                resolve()
            }
            ;
            if (this.autoPlay) {
                template2.replaceWith(node)
            } else {
                this.innerHTML = "";
                this.appendChild(node)
            }
        }
        )
    }
  }
customElements.define("external-video", ExternalVideo);


  theme.Blog = (function() {

  

    function Blog(container) {

      this.tagFilters();

    }

  

    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function() {

        var filterBy = document.getElementById('BlogTagFilter');

  

        if (!filterBy) {

          return;

        }

  

        filterBy.addEventListener('change', function() {

          location.href = filterBy.value;

        });

      }

    });

  

    return Blog;

  })();

  
  theme.CollectionHeader = (function() {
    var hasLoadedBefore = false;
  
    function CollectionHeader(container) {
      this.namespace = '.collection-header';
  
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        heroImageContainer.classList.remove('loading', 'loading--delayed');
        heroImageContainer.classList.add('loaded');
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      hasLoadedBefore = true;
    }
  
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };
  
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }
  
    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        // Do not load when no sidebar exists
        if(!this.container) {
          return;
        }
  
        this.onUnload();
  
        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
    var isAnimating = false;
  
    var selectors = {
      sortSelect: '#SortBy',
  
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
  
      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.context = container.getAttribute('data-context');
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });
  
      this.init();
    }
  
    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {

        /* Prevent extra JS from running for featured collection on a collection template */
        if (this.context && this.context === 'featured-collection') {
          this.colorSwatchHovering();
          return;
        }

        /* ========== [旧逻辑] 无 sectionId 也会跑筛选，购物车推荐等会发出 section_id=null（已停用）
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.initPriceRange();
        this.sidebar.init();
        ========== */

        // [新] 无 data-section-id 时不绑定筛选/AJAX，避免 section_id=null 导致集合页灰屏卡住
        if (!this.sectionId) {
          this.colorSwatchHovering();
          return;
        }

        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.initPriceRange();
        this.sidebar.init();
      },
  
      initSort: function() {
        this.sortSelect = document.querySelector(selectors.sortSelect);
  
        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },
  
      getSortValue: function() {
        return this.sortSelect.value || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.sortSelect.getAttribute('data-default-sortby');
      },
  
      onSortChange: function() {
        this.queryParams = new URLSearchParams(window.location.search);
  
        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // Delete if it exists
  
        window.location.search = this.queryParams.toString();
      },
  
      colorSwatchHovering: function() {
        // best-seller PC: click-lock handled by theme.initCollectionSizeBar (no swatch hover swap)
        if (this.container.dataset.collectionHandle === 'best-seller') {
          return;
        }

        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }
  
        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', () => {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = this.container.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', () => {
            var id = swatch.dataset.variantId;
            this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },
  
      /*====================
        Collection filters
      ====================*/
      initFilters: function() {
        var tags = document.querySelectorAll(selectors.tags);
  
        if (!tags.length) {
          return;
        }
  
        this.bindBackButton();
  
        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();
  
          window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
        }
  
        document.querySelectorAll(selectors.activeTags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });
  
        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },
  
      initPriceRange: function() {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
      },
  
      tagClick: function(evt) {
        var el = evt.currentTarget;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
  
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.parentNode;
        const newUrl = new URL(el.href);
  
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },
  
      onFormSubmit: function(evt) {
        var el = evt.target;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.closest('li');
        const formEl = el.closest('form');
        const formData = new FormData(formEl);
  
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },
  
      fetchOpenCollasibleFilters: function() {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },
  
      renderActiveTag: function(parent, el) {
        const textEl = parent.querySelector('.tag__text');
  
        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);
  
          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl?.innerText;
              newTag.appendChild(newTagLink);
  
              list.appendChild(newTag);
            });
          }
        }
      },
  
      renderFromFormData: function(formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },
  
      onReplaceAjaxContent: function(newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();
  
        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });
  
        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }
  
        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
      },
  
      openCollapsible: function(el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }
  
        el.classList.add(classes.isOpen);
      },
  
      renderCollectionPage: function(searchParams, updateURLHash = true) {
        /* ========== [旧逻辑] 仅 then、无 catch；请求失败时 isAnimating/unload 永不复位（已增强）
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-grid');
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();
            document.dispatchEvent(new CustomEvent('collection:reloaded'));
            isAnimating = false;
          });
        ========== */

        // [新] 失败时复位 isAnimating 并去掉灰层，避免筛选一直加载不出
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-grid');
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();

            document.dispatchEvent(new CustomEvent('collection:reloaded'));

            isAnimating = false;
          })
          .catch(function() {
            isAnimating = false;
            var grid = document.querySelector(selectors.collectionGrid);
            if (grid) grid.classList.remove('unload');
          });
      },
  
      bindBackButton: function() {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function(state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },
  
      updateScroll: function(animate) {
        var scrollToElement = document.querySelector('[data-scroll-to]');
        var scrollTo = scrollToElement && scrollToElement.offsetTop;
  
        if (!theme.config.bpSmall) {
          scrollTo -= 15;
        }
  
        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }
  
        if (animate) {
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        } else {
          window.scrollTo({top: scrollTo});
        }
      },
  
      setFilterStickyPosition: function() {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight - 3 + 'px';
  
        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 30 + 'px';
        }
      },
  
      forceReload: function() {
        this.init();
      },
  
      startLoading: function() {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });
  
    return Collection;
  })();
  
  theme.ColumnsWithImage = (function() {
    const selectors$t = {
      slider: '[data-slider]',
      sliderItem: '[data-slider-item]',
      left:'[data-slider-left]',
      right:'[data-slider-right]',
      sliderItemImage: '[data-media-container]',
      links: 'a, button',
      flickityButton: '.flickity-button',
    };
  
    function ColumnsWithImage(container) {
     this.container = container;
      this.slider = this.container.querySelector(selectors$t.slider);
      this.flkty = null;
      this.gutter = 0;
      this.maxVisiblePercent = 0;
      this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
      this.listen();
    }
  
    ColumnsWithImage.prototype = Object.assign({}, ColumnsWithImage.prototype, {
      initSlider: function() {
        this.slider.classList.remove(classes$l.carouselInactive);
  
        this.flkty = new Flickity(this.slider, {
          pageDots: false,
          cellAlign: 'left',
          groupCells: true,
          contain: true,
          on: {
            ready: () => {
              this.setSliderArrowsPosition(this.slider);
              setTimeout(() => {
                this.changeTabIndex();
                this.flkty.resize();
              }, 0);
            },
            change: () => {
              this.changeTabIndex();
            },
          },
        });
  
        Flickity.prototype._createResizeClass = function () {
          this.element.classList.add(classes$l.carouselResize);
        };
  
        Flickity.createMethods.push('_createResizeClass');
  
        const resize = Flickity.prototype.resize;
        Flickity.prototype.resize = function () {
          this.element.classList.remove(classes$l.carouselResize);
          resize.call(this);
          this.element.classList.add(classes$l.carouselResize);
        };
      },
  
      destroySlider: function() {
        this.slider.classList.add(classes$l.carouselInactive);
  
        if (this.flkty !== null) {
          this.flkty.destroy();
          this.flkty = null;
        }
            this.slider.addEventListener('scroll', () => {
            this.visibleDiv = this.getVisibleDiv();
            if (this.visibleDiv) {
            }
          });
         const sliderLeft = this.container.querySelector(selectors$t.left)
         const sliderRight = this.container.querySelector(selectors$t.right)
          sliderLeft?.addEventListener('click',()=>this.prevNextClick(this.maxVisiblePercent+1))
          sliderRight?.addEventListener('click',()=>this.prevNextClick(this.maxVisiblePercent-1))
      },
      getVisibleDiv: function() {
        const divs = document.querySelectorAll(selectors$t.sliderItem); // 替换为你的div类名 
        divs.forEach((div,i) => {
          const rect = div.getBoundingClientRect();
          const left = rect.left
          if (left<25) {
            this.maxVisiblePercent = i;
          }
        });
      },
      prevNextClick: function(num) {
          const count = num < 0 ? 0 : num
          const sliderItem = this.slider.querySelectorAll(selectors$t.sliderItem)
          const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
          const sliderPadding = parseInt(sliderStyle.paddingLeft);
          this.slider.scrollTo({
            top: 0,
            left: sliderItem[count].offsetLeft-sliderPadding,
            behavior: 'smooth',
          });
  },
      checkSlidesSize: function() {
        const sliderItemStyle = this.container.querySelector(selectors$t.sliderItem).currentStyle || window.getComputedStyle(this.container.querySelector(selectors$t.sliderItem));
        this.gutter = parseInt(sliderItemStyle.marginRight);
        const containerWidth = this.slider.offsetWidth;
        const itemsWidth = this.getItemsWidth();
        const itemsOverflowViewport = containerWidth < itemsWidth;
        if (window.innerWidth >= 768 && itemsOverflowViewport) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      },
  
      changeTabIndex: function() {
        const selectedElementsIndex = this.flkty.selectedIndex;
  
        this.flkty.slides.forEach((slide, index) => {
          slide.cells.forEach((cell) => {
            cell.element.querySelectorAll(selectors$t.links).forEach((link) => {
              link.setAttribute(attributes$i.tabIndex, selectedElementsIndex === index ? '0' : '-1');
            });
          });
        });
      },
  
      getItemsWidth: function() {
        let itemsWidth = 0;
        const slides = this.slider.querySelectorAll(selectors$t.sliderItem);
        if (slides.length) {
          slides.forEach((item) => {
            itemsWidth += item.offsetWidth + this.gutter;
          });
        }
  
        return itemsWidth;
      },
  
      listen: function() {
        if (this.slider) {
          this.checkSlidesSize();
          document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
        }
      },
  
      setSliderArrowsPosition: function(slider) {
        const arrows = slider.querySelectorAll(selectors$t.flickityButton);
        const image = slider.querySelector(selectors$t.sliderItemImage);
  
        if (arrows.length && image) {
          arrows.forEach((arrow) => {
            arrow.style.top = `${image.offsetHeight / 2}px`;
          });
        }
      },
  
      onBlockSelect: function(evt) {
        if (this.flkty !== null) {
          const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
          const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
          const groupIndex = Math.floor(index / slidesPerPage);
  
          this.flkty.select(groupIndex);
        } else {
          const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
          const sliderPadding = parseInt(sliderStyle.paddingLeft);
          const blockPositionLeft = evt.target.offsetLeft - sliderPadding;
  
          // Native scroll to item
          this.slider.scrollTo({
            top: 0,
            left: blockPositionLeft,
            behavior: 'smooth',
          });
        }
      },
  
      onUnload: function() {
        document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
      }
    });
  
    return ColumnsWithImage;
  })();
  theme.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');
  
          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }
  
        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
        this.hoverMenu();
      },
  
      hoverMenu: function() {
        const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
  
        detailsEl.forEach((detail) => {
          // if detail has :focus-within
          detail.addEventListener('focusin', () => {
            if (!detail.hasAttribute('open')) {
  
              // close all other details
              detailsEl.forEach((detail) => {
                detail.removeAttribute('open');
                detail.setAttribute('aria-expanded', 'false');
              });
  
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
  
          detail.addEventListener('focusout', () => {
            if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
  
          detail.addEventListener('mouseover', () => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
  
          detail.addEventListener('mouseleave', () => {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        });
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }
  
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.announcementBar.unload();
  
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return HeaderSection;
  })();
  
  theme.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      lowInventory: 'inventory--low',
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.inDrawer = (container.dataset.drawer === 'true');
      this.modal;
      this.drawer;
      this.bundleVariants;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }
      // Overwrite some settings when loaded in drawer
      if (this.inDrawer) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-drawer';
        this.drawer = document.getElementById('QuickShopDrawer-' + productId);
      }
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        pricePc: '[data-product-price1]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
  
        availabilityContainer: '[data-store-availability-holder]'
      };
  
      this.cacheElements();
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }
      this.init();
      
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this, 'modal'));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }
        if (this.inDrawer) {
          document.addEventListener('drawerOpen.QuickShopDrawer-' + this.productId, this.openModalProduct.bind(this, 'drawer'));
          document.addEventListener('drawerClose.QuickShopDrawer-' + this.productId, this.closeModalProduct.bind(this));
        }
        if (!this.inModal && !this.inDrawer) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
  
          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          pricePc: this.container.querySelector(this.selectors.pricePc),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },
  
      formSetup: function() {
        const bundleChildProductsEle = this.container.querySelector('.class-bundleChildProducts');
        if(bundleChildProductsEle){
          const jsonVal = bundleChildProductsEle.textContent;
          this.bundleVariants = JSON.parse(jsonVal);
        }

        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        this.setBundleProduct();
  
        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          try {
            window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
          } catch (error) {
            if (error.name === 'QuotaExceededError') {
              // Storage quota exceeded, clear old data and retry
              window.localStorage.removeItem('theme-recent');
              try {
                window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
              } catch (e) {
                console.warn('无法保存最近浏览记录：存储空间不足');
              }
            }
          }
        }
      },
  
      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
        this.variantsObject.forEach(item=>{
          item.hasSku = true
        })
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };
  
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('updateSwatch', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }
  
        this.variants = new theme.Variants(options);
  
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantImageInit' + this.settings.namespace, this.variantImageInit.bind(this));
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
  
          // Update inventory on page load
          this.updateInventory({ detail: { variant: this.variants.currentVariant } });
  
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);
  
            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }
  
        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      variantImageInit: function(evt) {
        var variant = evt.detail.variant;
        var nextVariant = evt.detail.nextVariant;
        var imagesDom = this.container.querySelectorAll('.product-slideshow.flickity-enabled .flickity-viewport .product-main-slide');
        if (window.innerWidth > 767 && this.container.parentElement?.className?.includes('shopify-section--main-product')) {
          if (variant) {
            const firstColor = this.container.querySelectorAll('[data-dynamic-variants-enabled] .variant-input-wrap[name="Color"] input')?.[0].getAttribute('value');
            const colorOption = variant.options.length > 2 ? 'option2' : 'option1';
            let blockImage = false;
            imagesDom.forEach((image, index) => {
              if (image.getAttribute('data-image-id') == variant.featured_media.id || (firstColor === variant[colorOption] && index === 0)) {
                blockImage = true;
                image.style.display = 'block';
              } else if (nextVariant && image.getAttribute('data-image-id') == nextVariant.featured_media.id) {
                blockImage = false;
                image.style.display = 'none';
              } else if (blockImage) {
                image.style.display = 'block';
              } else {
                image.style.display = 'none';
              }
            });
          }
        } else {
          imagesDom.forEach(image => {
            image.style.display = 'inline-block';
          })
        }
      },

      setBundleProduct: function(){ // 捆绑产品函数处理
        const bundle_ele = this.container.querySelector('.product_bundle_cus-new');
        if(!bundle_ele) return;
        const bundleChildsEle = bundle_ele.querySelectorAll('.bundle-product-item');

        const {col_arr, size_arr} = this._format_bundle_selectval(this.variants.currentlySelectedValues);
        if(!this.bundleVariants) return;
        const new_bundle_variants = this.bundleVariants.map((item,index)=>{
          return item.variants.filter(e=>e.option1 == col_arr[index])
        });
        bundleChildsEle.forEach((ele, index) => {
          const childele = ele.querySelectorAll(".variant-input");
          const childImg = ele.querySelector(".bundle-product-img");
          const childProVarlist = new_bundle_variants[index];
          if(childImg){
            childImg.src = childProVarlist[0]?.featured_image.src;
          }

          childele.forEach((cele) => {
            const input = cele.querySelector('input');
            const label = cele.querySelector('label');
            const obj = childProVarlist.find( o => o.option2 == input.value);
            input.classList.remove(classes.disabled);
            label.classList.remove(classes.disabled);
            if (!obj.available) {
              input.classList.add(classes.disabled);
              label.classList.add(classes.disabled);
            }

          })
        })
        let variantIdsStr = '';
        let variant = { available: true };
        const cartBtn = this.container.querySelector(this.selectors.addToCart);
        this.bundleVariants.forEach((item,index)=>{
          const inx = index;
          item.variants.forEach(v=>{
            if(col_arr[inx] == v.options[0] && size_arr[inx] == v.options[1]){
              variantIdsStr += v.id + ',';
              if(!v.available){
                variant.available = false;
              }
            }
          })
        })
        cartBtn.dataset.bundlevariantid = variantIdsStr;
        const variantIdsvalStr = col_arr.map((item,index)=>{
          return item + ' / ' + size_arr[index]
        }).join(',');
        cartBtn.dataset.bundlevariantstr = variantIdsvalStr;

        return variant;
      },
      _format_bundle_selectval:function(selected_bundle_var_val){ // 捆绑-格式化选择值
        const new_arr_list = JSON.parse(JSON.stringify(selected_bundle_var_val));
        const col_arr = new_arr_list[0]?.value?.split('/');
        new_arr_list.shift();
        const size_arr = new_arr_list.map(o=>o.value);
        return {col_arr, size_arr}
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        new theme.AjaxProduct(this.cache.form);
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        var colorLabel = this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"]`);
        if (colorLabel) {
          colorLabel.textContent = color;
        }
      },
  
      updateCartButton: function(evt) {
        let variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
  
        if (!cartBtn) return;
        if (!cartBtnText) return;
        const bundle_pro_ele = this.container.querySelector(".product_bundle_cus-new");
        if(bundle_pro_ele && this.bundleVariants){ // 捆绑产品
          variant = this.setBundleProduct();
        }
        var vipCartLocked = cartBtn.hasAttribute('data-vip-cart-locked');
        
        if (variant) {
          if (variant.available) {
            var defaultText = cartBtnText.dataset.defaultText;
            if (vipCartLocked) {
              cartBtn.classList.add(classes.disabled);
              cartBtn.disabled = true;
              cartBtnText.textContent = defaultText;
            } else {
              // Available, enable the submit button and change text
              cartBtn.classList.remove(classes.disabled);
              cartBtn.disabled = false;
              cartBtnText.textContent = defaultText;
            }
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant) {
          // 清仓赠品合格用户：变体切换时保持 $0 展示（真免单仍靠 PLGIFT）
          if (this.container.getAttribute('data-clearance-gift-eligible') === 'true') {
            var zeroHtml = theme.Currency.formatMoney(0, theme.settings.moneyFormat);
            var listHtml = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
            if (this.cache.price) {
              this.cache.price.innerHTML = zeroHtml;
              this.cache.price.classList.add(classes.onSale);
            }
            if (this.cache.pricePc) {
              this.cache.pricePc.innerHTML = zeroHtml;
              this.cache.pricePc.classList.add(classes.onSale);
            }
            if (this.cache.comparePrice) {
              this.cache.comparePrice.innerHTML = listHtml;
            }
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.remove(classes.hidden);
            }
            return;
          }

          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
          this.cache.pricePc.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.pricePc.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
  
            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            this.cache.pricePc.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;
  
        // Always start on index 0
        this.settings.currentSlideIndex = 0;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="'+set+'"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },
  
      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
  
        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function(set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Override to display in stock message for sold out variants with policy set to continue
        // Must be set to true in order to display in stock message for sold out variants
        const inStockForOOSAndContinueSelling = false;
  
        if (!variant) {
          // Variant is unavailable
          // So we want to hide both the inventory quantity + incoming transfer notice
          this.toggleInventoryQuantity('hidden', false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        // Inventory management is nil
        // So we want to hide the low inventory message but show an In stock status
        // And hide the incoming transfer notice
        if (!variant.inventory_management) {
          this.toggleInventoryQuantity('visible', false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          const variantInventoryObject = window.inventories[this.productId][variant.id];
  
          const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};
  
          this.toggleInventoryQuantity(undefined, quantity);
  
          if (inStockForOOSAndContinueSelling) {
            if (quantity <= 0 && policy === 'continue') {
              this.toggleInventoryQuantity('visible', false);
              this.toggleIncomingInventory(false);
              return;
            }
          }
  
          if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
            this.toggleIncomingInventory(true, next_incoming_date, policy);
          } else {
            this.toggleIncomingInventory(false);
          }
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(state = undefined, quantity) {
        const productInventoryEl = this.container.querySelector(this.selectors.inventory);
        const inventorySalesPoint = productInventoryEl.closest('.sales-point');
  
        if (state && state === 'hidden') {
          // variant is unavailable
          // hide and return
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
  
          return;
        }
  
        let showLowInventoryMessage = false;
  
        // Check if we should show low inventory message
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
          showLowInventoryMessage = true;
        }
  
        if (parseInt(quantity) > 0 || (state && state === 'visible')) {
          if (showLowInventoryMessage) {
            productInventoryEl.parentNode.classList.add(classes.lowInventory);
            if (quantity > 1) {
              productInventoryEl.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
            } else {
              productInventoryEl.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
            }
          } else {
            productInventoryEl.parentNode.classList.remove(classes.lowInventory);
            productInventoryEl.textContent = theme.strings.inStockLabel;
          }
  
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.remove(classes.hidden);
          }
  
        } else {
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
        }
      },
  
      toggleIncomingInventory: function(showIncomingInventory, incomingInventoryDate, policy) {
  
        const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
        const incomingInventoryIcon = incomingInventoryEl.querySelector('.icon-and-text');
  
        if (!incomingInventoryEl) return;
  
        const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
        const textEl = incomingInventoryEl.querySelector('.js-incoming-text');
  
        // If incoming inventory block is disabled, hide it
        if (!incomingInventoryBlockEnabled) {
          incomingInventoryEl.classList.add(classes.hidden);
          return;
        }
  
        if (showIncomingInventory) {
          if (incomingInventoryDate) {
            textEl.textContent = theme.strings.willBeInStockAfter.replace('[date]', incomingInventoryDate);
            incomingInventoryEl.classList.remove(classes.hidden);
          } else {
            textEl.textContent = theme.strings.waitingForStock;
            incomingInventoryEl.classList.remove(classes.hidden);
          }
  
          // When OOS and incoming inventory and continue selling disabled, update icon to low inventory
          if (incomingInventoryIcon) {
            if (policy !== 'continue') {
              incomingInventoryIcon.classList.add(classes.lowInventory);
            } else {
              incomingInventoryIcon.classList.remove(classes.lowInventory);
            }
          }
  
        } else {
          incomingInventoryEl.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      initVimeoVideo: function(div) {
        videoObjects[div.id] = new theme.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        var nextVariant = evt.detail.nextVariant;
        const handleLastVariant = evt.detail.handleLastVariant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
        var imagesDom = this.container.querySelectorAll('.product-slideshow.flickity-enabled .flickity-viewport .product-main-slide');
        if (window.innerWidth > 767 && this.container.parentElement?.className?.includes('shopify-section--main-product')) {
          const variantWrappers = this.container.querySelectorAll('[data-dynamic-variants-enabled] .variant-wrapper');
          const isFirstVariant = Array.from(variantWrappers).every((item, index) => item.querySelectorAll('input')[0].checked || index === (variantWrappers.length - 1));
          // const colorOption = variant.options.length > 2 ? 'option2' : 'option1';
          if (!handleLastVariant) {
            let blockImage = false;
            imagesDom.forEach((image, index) => {
              if (image.getAttribute('data-image-id') == variant.featured_media.id || (isFirstVariant && index === 0)) {
                blockImage = true;
                image.style.display = 'block';
              } else if (nextVariant && image.getAttribute('data-image-id') == nextVariant.featured_media.id) {
                blockImage = false;
                image.style.display = 'none';
              } else if (blockImage) {
                image.style.display = 'block';
              } else {
                image.style.display = 'none';
              }
            });
          }
        } else {
          imagesDom.forEach(image => {
            image.style.display = 'block';
          })
        }
  
        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },
  
      initProductSlider: function(variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          },
          prevNextButtons: true
        };
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }
  
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },
  
      onSliderInit: function(slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },
  
      onSlideChange: function(index) {
        if (!this.flickity) return;
  
        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
  
        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
                        this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
                        this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function(type) {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;
  
          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);
  
            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-' + type);
  
              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-' + type);
              }
  
              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-' + type);
              }
            });
  
            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            if (form) {
              var formId = form.getAttribute('id');
              blocks.querySelectorAll('[form]').forEach(el => {
                el.setAttribute('form', formId);
              });
            }
            
            blocks.querySelectorAll('.product-block--tab').forEach(el => {
              el.remove();
            });
            var buyerConsentDrawer = blocks.querySelector('#shopify-buyer-consent-drawer');
            if (buyerConsentDrawer) {
              buyerConsentDrawer.remove();
            }

            this.blocksHolder.innerHTML = '';
            if (blocks.querySelector('[data-add-to-cart]')) {
              var __atcQv = blocks.querySelector('[data-add-to-cart]');
              __atcQv?.classList?.remove('btn--loading');
              if (!__atcQv?.hasAttribute('data-vip-cart-locked')) {
                __atcQv?.removeAttribute('disabled');
              }
            }
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');
  
            this.cacheElements();
  
            this.formSetup();
            this.updateModalProductInventory();
  
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this));
  
          this.productSetup();
          this.videoSetup();
  
          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function(evt) {
                if (evt.detail.productId === this.productId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
  
        AOS.refreshHard();
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              this.mediaLoaded(evt);
            }.bind(this));
  
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },
  
      onUnload: function() {
        theme.ProductMedia.removeSectionModels(this.sectionId);
  
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });
  
    return Product;
  })();
  
  theme.RecentlyViewed = (function() {
    var init = false;
  
    function RecentlyViewed(container) {
      if (!container) {
        return;
      }
  
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
      this.imageSizes = this.container.getAttribute('data-image-sizes');
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };
  
    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }
  
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch('/products/'+ handle +'.js').then(function(response) {
              return response.text();
            }).then(function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute('data-recent-count');
  
        var i = 0;
  
        Object.keys(products).forEach(function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);
  
          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }
  
          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return;
          }
  
          i++;
  
          // New or formatted properties
          const widths = [180, 360, 540, 720, 900];
          product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.Images.buildImagePath(product.featured_image),
          product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths),
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
  
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }.bind(this));
  
        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }
  
        var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf, this.imageSizes);
  
        this.outputContainer.innerHTML = productMarkup;
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          try {
            sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
          } catch (error) {
            if (error.name === 'QuotaExceededError') {
              // Storage quota exceeded, clear old data and retry
              sessionStorage.removeItem('recent-products');
              try {
                sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
              } catch (e) {
                console.warn('无法保存产品信息：存储空间不足');
              }
            }
          }
        }
      },
  
      onUnload: function() {
        init = false;
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    if (!document.documentElement.classList.contains('modal-open')) {
      theme.initQuickShop();
    }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);
    theme.sections.register('columns-with-image', theme.ColumnsWithImage);

    theme.initGlobals();
    theme.initCollectionSizeBar();
    // theme.initQuickShop();
    setTimeout(()=>{
      theme.initQuickShop(); // product-grid-item文件有配置自定义代码需要延时执行
      theme.initCollectionSizeBar();
    }, 400)
    theme.rteInit();
    if (theme.vipCartGuard) {
      theme.vipCartGuard.init();
    }

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
    
		const webModel = document.querySelectorAll('.custom-model-pop-web-wrapper');
    if (webModel.length) {
      theme.ModelRegister();
    }
  });
  const test = window.location.pathname;
  const index = test.lastIndexOf("\/");
  const page_category = test.slice(1,index) || 'Home'
  const page_name = test.substring(index + 1,test.length) || 'Home'
  // Notification 通知
  $(document).on('click', '.pushowl-optin .js-pushowl-btn-container button', function () {
    const button_name = $(this)[0]?.innerText
    window.dataLayer.push({
      event: "notification_click",
      button_name: button_name,
      page_category: page_category,
      page_name: page_name
    });
  })
  // Promotion Bar / Button 促销模块
  $(document).on('click', '.announcement-bar #AnnouncementSlider', function (event) {
    if (event.target.classList.contains('flickity-button-icon') || event.target.classList.contains('flickity-button')) {
      var promotion_name = $('.flickity-slider .is-selected')[0]?.innerText
      var promotion_click = 'promotion button';
    } else {
      var promotion_name = event.target.innerText
      var promotion_click = 'top promotion bar'
    }
    var click_url = $(this).find('.announcement-link').attr('href')
    window.dataLayer.push({
      event: "promotion_click",
      promotion_name: promotion_name,
      position: promotion_click,
      click_url: click_url,
      page_category: page_category,
      page_name: page_name,
    });
  })
  // First Navigation Bar 一级导航栏
    $(document).on('click', '.site-nav__link', function (event) {
      var first_navi_category = $(this).attr('data-name')
      window.dataLayer.push({
        event: "first_navi_click",
        first_navi_category: first_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.mobile-nav > .mobile-nav__item_first > .mobile-nav__link', function (event) {
      var first_navi_category = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "first_navi_click",
        first_navi_category: first_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.mobile-nav > .mobile-nav__item_first > .mobile-nav__has-sublist > .mobile-nav__link', function (event) {
      var first_navi_category = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "first_navi_click",
        first_navi_category: first_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    // 移动端二级
    $(document).on('click', '.mobile-nav__second', function (event) {
      var first_navi_category = $(this).parents('.mobile-nav__item_first').find('.mobile-nav__has-sublist .mobile-nav__link')[0]?.innerText
      var second_navi_category = $(this).find('.mobile-nav__link')[0]?.innerText
      window.dataLayer.push({
        event: "second_navi_click",
        first_navi_category: first_navi_category,
        second_navi_category: second_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.menu-item-account-icon .account-modal-signin', function (event) {
      var first_navi_category = $(this).attr('data-name')
      window.dataLayer.push({
        event: "first_navi_click",
        first_navi_category: first_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.account-modal > .account-modal-signin', function (event) {
      var first_navi_category = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "first_navi_click",
        first_navi_category: first_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.account-modal-create', function (event) {
      var first_navi_category = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "first_navi_click",
        first_navi_category: first_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    // 货币变更点击
    $(document).on('click', '.disclosure-list__item', function (event) {
      var original_currency = $('.disclosure-list__label')[0]?.innerText
      var current_curency = $(this).find('.disclosure-list__label')[0]?.innerText
      window.dataLayer.push({
        event: "change_currency",
        original_currency: original_currency,
        current_curency: current_curency,
        page_category: page_category,
        page_name: page_name
      });

    })
    // second navigation click rate 二级导航栏点击
    $(document).on('click', '.site-nav__dropdown-link', function (event) {
      // A11Y-B：父级从 .site-nav__details 改为 .site-nav__item（旧：.parents('.site-nav__details')）
      var first_navi_category = $(this).parents('.site-nav__item').find('.site-nav__link')[0]?.innerText
      var second_navi_category = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "second_navi_click",
        first_navi_category: first_navi_category,
        second_navi_category: second_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.hxMegaImg img', function (event) {
      // A11Y-B：父级从 .site-nav__details 改为 .site-nav__item
      var first_navi_category = $(this).parents('.site-nav__item').find('.site-nav__link')[0]?.innerText
      var second_navi_category = $(this).parents('.mega-menu__image-push').find('.mega-menu__heading')[0]?.innerText
      window.dataLayer.push({
        event: "second_navi_click",
        first_navi_category: first_navi_category,
        second_navi_category: second_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    // 三级导航栏点击
    $(document).on('click', '.mobile-nav__grandchildlist .mobile-nav__link', function (event) {
      var first_navi_category = $(this).parents('.mobile-nav__item_first').find('.mobile-nav__has-sublist .mobile-nav__link')[0]?.innerText
      var second_navi_category = $(this).parents('.thrid_navi').prev().find('.mobile-nav__link')[0]?.innerText
      var thrid_navi_category = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "third_navi_click",
        first_navi_category: first_navi_category,
        second_navi_category: second_navi_category,
        third_navi_category:thrid_navi_category,
        page_category: page_category,
        page_name: page_name
      });
    })
    // banner click rate 展示横幅点击  
    $(document).on('click', '.slideshow-wrapper .hero__slide-link', function (event) {
      var $img = $(this).siblings('.hero__image-wrapper').find('img.small--hide'); // 找到对应图片
      var imageWidth = $img.width();
      var offsetX = event.offsetX;

      var positionCategory;
      if (offsetX < imageWidth / 3) {
          positionCategory = 1;
      } else if (offsetX > 2 * imageWidth / 3) {
          positionCategory = 3;
      } else {
          positionCategory = 2;
      }

      var click_url = $(this).attr('href');   // <a> 才有 href
      var banner_name = $img.attr('alt');     // 图片 alt 当做名称
      window.dataLayer.push({
        event: "banner_interaction",
        banner_name: banner_name,
        banner_position: positionCategory,
        click_url: click_url,
        page_category: page_category,
        page_name: page_name
      });
    });

    $(document).on('click', '.slideshow-wrapper image-element', function (event) {
      var $img = $(this).find('img');
      var imageWidth = $img.width();
      var offsetX = event.offsetX;

      var positionCategory;
      if (offsetX < imageWidth / 3) {
          positionCategory = 1;
      } else if (offsetX > 2 * imageWidth / 3) {
          positionCategory = 3;
      } else {
          positionCategory = 2;
      }

      var click_url = $(this).siblings('a.hero__slide-link').attr('href');
      var banner_name = $img.attr('alt');
      window.dataLayer.push({
        event: "banner_interaction",
        banner_name: banner_name,
        banner_position: positionCategory,
        click_url: click_url,
        page_category: page_category,
        page_name: page_name
      });
    });

    $(document).on('click', '.promo-grid .promo-grid__slide-link', function (event) {
      // 获取图片的宽度和父容器的宽度
      var imageWidth = $(this).width();
      // 获取点击位置相对于图片的偏移
      var clickX = event.offsetX; 
      // 计算点击位置的分类
      var positionCategory;
      if (clickX < imageWidth / 3) {
          positionCategory = 1; // 左
      } else if (clickX > 2 * imageWidth / 3) {
          positionCategory = 3; // 右
      } else {
          positionCategory = 2; // 中
      }
      var click_url = $(this).attr('href')
      var banner_name = $(this).parents('.flex-grid__item').find('.rte--strong')[0]?.innerText
      window.dataLayer.push({
        event: "banner_interaction",
        banner_name: banner_name,
        banner_position: positionCategory,
        click_url: click_url,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.slideshow-wrapper .hero__slide-link', function (event) {
      var banner_name = $(this).parents('.slideshow__slide').find('.animation-contents')[0]?.innerText
      var click_url = $(this).attr('href')
      var imageWidth = $(this).width();
      // 获取点击位置相对于图片的偏移
      var clickX = event.offsetX; 
      // 计算点击位置的分类
      var positionCategory;
      if (clickX < imageWidth / 3) {
          positionCategory = 1; // 左
      } else if (clickX > 2 * imageWidth / 3) {
          positionCategory = 3; // 右
      } else {
          positionCategory = 2; // 中
      }
      window.dataLayer.push({
        event: "banner_interaction",
        banner_name: banner_name,
        banner_position: positionCategory,
        click_url: click_url,
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.index-section--hero-video .animation-contents a', function (event) {
      var banner_name = $(this).parents('.hero__text-shadow').find('.hero__title .animation-contents')[0]?.innerText
      var click_url = $(this).attr('href')
      var imageWidth = $(this).width();
      // 获取点击位置相对于图片的偏移
      var clickX = event.offsetX; 
      // 计算点击位置的分类
      var positionCategory;
      if (clickX < imageWidth / 3) {
          positionCategory = 1; // 左
      } else if (clickX > 2 * imageWidth / 3) {
          positionCategory = 3; // 右
      } else {
          positionCategory = 2; // 中
      }
      window.dataLayer.push({
        event: "banner_interaction",
        banner_name: banner_name,
        banner_position: positionCategory,
        click_url: click_url,
        page_category: page_category,
        page_name: page_name
      });
    })

    $(document).on('click', '.newsletter-section .input-group-btn button', function (event) {
      window.dataLayer.push({
        event: "subscription_submitted",
        button_position: 'newslette',
        page_category: page_category,
        page_name: page_name
      });
    })
    $(document).on('click', '.footer__newsletter-btn', function (event) {
      window.dataLayer.push({
        event: "subscription_submitted",
        button_position: 'Footer',
        page_category: page_category,
        page_name: page_name
      });
    })
    // footer navigation click rate 底部导航栏点击
    $(document).on('click', '.site-footer__linklist li a', function (event) {
      var footer_menu_category = $(this).parents('.grid__item').find('.footer__title')[0]?.innerText
      var button_name = $(this)[0]?.innerText
      var click_url = $(this).attr('href')
      window.dataLayer.push({
        event: "footer_click",
        footer_menu_category: footer_menu_category,
        button_name: button_name,
        click_url: click_url,
        page_category: page_category,
        page_name: page_name
      });
    })
    // social platform share 社媒分享点击
    $(document).on('click', '.social-icons li a', function (event) {
      var social_platform = $(this)[0]?.innerText
      window.dataLayer.push({
        event: "social_sharing",
        social_platform: social_platform,
        page_category: page_category,
        page_name: page_name
      });
    })
    // chat bot click 咨询窗口点击
    $(document).on('click', '#conversation-badge', function (event) {
      window.dataLayer.push({
        event: "chat_bot_started",
        page_category: page_category,
        page_name: page_name
      });
    })
    function processFilterEvent(element) {
      const clickTag = element.find('.tag__text')[0].innerText;
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      let colors = params.getAll('filter.v.option.color').join(',');
      let size = params.getAll('filter.v.option.size').join(',');
      let sortBy = params.getAll('sort_by');
      const priceGte = params.get('filter.v.price.gte');
      const priceLte = params.get('filter.v.price.lte');
      if (element.parents('.hx-filter-color').length > 0) {
          colors = colors
      }
      if (element.parents('.hx-filter-size').length > 0) {
          size = size
      }
      window.dataLayer.push({
          event: "filter",
          color: colors,
          size: size,
          price: `From ${priceGte} to ${priceLte}`,
          sort_by: sortBy,
      });
    }
    let filterTimer;
    $(document).on('click', '.filter-form .text-label', function (event) {
        clearTimeout(filterTimer);
        filterTimer = setTimeout(() => {
            processFilterEvent($(this));
        }, 200); // 延迟 200ms
    });
    $('#SortBy').on('change', function() {
        var selectedValue = $(this).find('option:selected').data('name');
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        let colors = params.getAll('filter.v.option.color').join(',');
        let size = params.getAll('filter.v.option.size').join(',');
        const priceGte = params.get('filter.v.price.gte');
        const priceLte = params.get('filter.v.price.lte');
        window.dataLayer.push({
          event: "filter",
          color: colors,
          size: size,
          price: `From ${priceGte} to ${priceLte}`,
          sort_by: selectedValue,
        });
    });

    // submission rate of reviews 产品详情页的评价提交
    $(document).on('click', '.loox-overlay ._icon-label_1vllo_1', function (event) {

    })
    // adding product 增加商品
    $(document).on('click', '.page-content--product .js-qty__adjust--plus', function (event) {
      var product_name = $(this).parents('.page-content--product').find('.product-single__title')[0]?.innerText
      var product_id = $(this).parents('.page-content--product').find('.product-single__title').attr('data-productId')
      var product_value = $(this).parents('.page-content--product').find('.product__price')[0]?.innerText
      var product_currency = window.Shopify.currency?.active
      var orginal_quantity = $(this).parents('.page-content--product').find('.product__quantity_num')[0]?.innerText
      var product_current_quantity = Number($(this).parents('.page-content--product').find('.product__quantity_num')[0]?.innerText) + 1
      window.dataLayer.push({
        event: "add_product",
        product_name: product_name,
        product_id: product_id,
        product_value:product_value,
        product_currency:product_currency,
        product_orginal_quantity:orginal_quantity,
        product_current_quantity:product_current_quantity,
        page_category: page_category,
        page_name: page_name
      });
    })
    // removing product 减少商品
    $(document).on('click', '.page-content--product .js-qty__adjust--minus', function (event) {
      var product_name = $(this).parents('.page-content--product').find('.product-single__title')[0]?.innerText
      var product_id = $(this).parents('.page-content--product').find('.product-single__title').attr('data-productId')
      var product_value = $(this).parents('.page-content--product').find('.product__price')[0]?.innerText
      var product_currency = window.Shopify.currency?.active
      var orginal_quantity = $(this).parents('.page-content--product').find('.product__quantity_num')[0]?.innerText
      var product_current_quantity = Number($(this).parents('.page-content--product').find('.product__quantity_num')[0]?.innerText) - 1
      window.dataLayer.push({
        event: "remove_product",
        product_name: product_name,
        product_id: product_id,
        product_value:product_value,
        product_currency:product_currency,
        product_orginal_quantity:orginal_quantity,
        product_current_quantity:product_current_quantity,
        page_category: page_category,
        page_name: page_name
      });
    })
    // account register rate 账户注册率
    $(document).on('click', '.account-wrapper .registerBtn', function (event) {
      window.dataLayer.push({
        event: "account_register",
        page_category: page_category,
        page_name: page_name
      });
    })
    // account signin rate 账户登录率
    $(document).on('click', '.account-wrapper .loginBtn', function (event) {
      window.dataLayer.push({
        event: "account_signin",
        page_category: page_category,
        page_name: page_name
      });
    })
    // 侧边栏购物车推荐商品点击
    $(document).on('change', '.cart-recommended .gproduct-item-sizes', function (event) {
      var product_name = $(this).parents('.gproduct-item-right').find('.grid-product__title')[0]?.innerText
      var product_id = $(this).parents('.gproduct-item-right').find('.grid-product__title').attr('data-productId')
      var product_value = $(this).parents('.gproduct-item-right').find('.grid-product__price')[0]?.innerText
      var product_currency = window.Shopify.currency?.active
      var product_variant = $(this).find('option:selected').text()
      window.dataLayer.push({
        event: "cart_recommend_variant_click",
        product_name: product_name,
        product_id: product_id,
        product_value:product_value,
        product_currency:product_currency,
        product_variant:product_variant,
        page_category: page_category,
        page_name: page_name
      });
    })
    // Buy It With：按颜色过滤 Size 下拉，未选 Size 时阻止加购
    function clearCartUpsellSizeFlash($scope) {
      var $root = $scope ? $($scope) : $('#CartDrawer');
      $root.find('select.gproduct-item-sizes--error').removeClass('gproduct-item-sizes--error');
    }
    function shakeCartUpsellSize($select) {
      if (!$select || !$select.length) return;
      var el = $select[0];
      $select.removeClass('cart-upsell-size-shake');
      void el.offsetWidth;
      $select.addClass('cart-upsell-size-shake');
      window.setTimeout(function() {
        $select.removeClass('cart-upsell-size-shake');
      }, 320);
    }
    function clearCartUpsellFormErrors($card) {
      if (!$card || !$card.length) return;
      $card.find('.product-single__form .errors').remove();
      clearCartUpsellSizeFlash($card);
    }
    $(document).on('mousedown touchstart', '#CartDrawer .cart-recommended .product-block-r .add-to-cart, #CartDrawer .giftBag-container .add-to-cart', function () {
      var $btn = $(this);
      var $card = $btn.closest('.gproduct-item-container');
      var $select = $card.find('select.gproduct-item-sizes[data-cart-upsell="true"]');
      if ($select.length && !$select.val()) {
        clearCartUpsellSizeFlash($card);
        $select.addClass('gproduct-item-sizes--error');
        shakeCartUpsellSize($select);
      }
    });
    $(document).on('mouseup touchend touchcancel', function () {
      clearCartUpsellSizeFlash();
    });
    function filterCartUpsellSizes($card) {
      var $select = $card.find('select.gproduct-item-sizes[data-cart-upsell="true"]');
      if (!$select.length) return;
      clearCartUpsellFormErrors($card);
      var activeColor = $card.find('.color-swatch.is-active').attr('data-color');
      var currentSize = $select.find('option:selected').attr('data-size');
      var matchedValue = '';
      $select.find('option').each(function () {
        var $opt = $(this);
        if (!$opt.val()) {
          this.hidden = false;
          return;
        }
        var color = $opt.attr('data-color');
        var show = !activeColor || !color || color === activeColor;
        this.hidden = !show;
        if (show && currentSize && $opt.attr('data-size') === currentSize && !this.disabled && !matchedValue) {
          matchedValue = $opt.val();
        }
      });
      if (matchedValue) {
        $select.val(matchedValue);
      } else {
        $select.val('');
      }
    }
    function initCartUpsellCards(root) {
      $(root || document).find('.cart-recommended__item .gproduct-item-container').each(function () {
        var $card = $(this);
        if (!$card.find('select.gproduct-item-sizes[data-cart-upsell="true"]').length) return;
        var $firstSwatch = $card.find('.color-swatch').first();
        if ($firstSwatch.length && !$card.find('.color-swatch.is-active').length) {
          $firstSwatch.addClass('is-active');
        }
        filterCartUpsellSizes($card);
      });
    }
    window.themeCartUpsellInit = initCartUpsellCards;
    function setCartUpsellImage($card, imgUrl) {
      if (!imgUrl) return;
      var $img = $card.find('.grid-product__content img').first();
      if (!$img.length) return;
      $img.attr('src', imgUrl);
      $img.removeAttr('srcset');
      $img.removeAttr('data-src');
      $img.removeAttr('data-srcset');
      $img.closest('picture').find('source').remove();
    }
    $(document).on('change', '.cart-recommended select.gproduct-item-sizes[data-cart-upsell="true"]', function () {
      clearCartUpsellFormErrors($(this).closest('.gproduct-item-container'));
    });
    $(document).on('click', '.cart-recommended .color-swatch', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var $swatch = $(this);
      var $card = $swatch.closest('.gproduct-item-container');
      clearCartUpsellFormErrors($card);
      $card.find('.color-swatch').removeClass('is-active');
      $swatch.addClass('is-active');
      $card.find('.color-swatch').attr('aria-pressed', 'false');
      $swatch.attr('aria-pressed', 'true');
      var imgUrl = $swatch.attr('data-variant-image');
      if (!imgUrl) {
        var color = $swatch.attr('data-color');
        $card.find('select.gproduct-item-sizes option').each(function () {
          if ($(this).attr('data-color') === color && $(this).attr('data-src')) {
            imgUrl = $(this).attr('data-src');
            return false;
          }
        });
      }
      setCartUpsellImage($card, imgUrl);
      filterCartUpsellSizes($card);
      $swatch.blur();
      return false;
    });
    initCartUpsellCards(document);
    $(document).on('cart:updated cart:build', function () {
      setTimeout(function () { initCartUpsellCards(document); }, 50);
    });
    // 侧边栏购物车推荐商品点击
    $(document).on('click', '.cart-recommended .product-block-r .add-to-cart, .giftBag-container .add-to-cart', function (event) {
      var $btn = $(this);
      var $card = $btn.closest('.gproduct-item-container');
      var $select = $card.find('select.gproduct-item-sizes[data-cart-upsell="true"]');
      if ($select.length && !$select.val()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
      var product_name = $btn.parents('.gproduct-item-right').find('.grid-product__title')[0]?.innerText
      var product_id = $btn.parents('.gproduct-item-right').find('.grid-product__title').attr('data-productId')
      var product_value = $btn.parents('.gproduct-item-right').find('.grid-product__price')[0]?.innerText
      var product_currency = window.Shopify.currency?.active
      var product_variant = $btn.parents('.gproduct-item-right').find('option:selected').text()
      window.dataLayer.push({
        event: "cart_recommend_atc_click",
        product_name: product_name,
        product_id: product_id,
        product_value:product_value,
        product_currency:product_currency,
        product_variant:product_variant,
        page_category: page_category,
        page_name: page_name
      });
    })
})();
